// import React, { useState, useEffect } from 'react';
// import { Formik, Form, Field, FieldArray, ErrorMessage } from 'formik';
// import * as Yup from 'yup';
// import UploadImage from '../../../../../../_metronic/helpers/components/ImageUpload';
// import UploadVideo from '../../../../../../_metronic/helpers/components/ImageUpload/index2';
// import { KTIcon } from '../../../../../../_metronic/helpers';
// import { initialUser, User } from '../core/_models'
// import { FC } from 'react'
// import { useQueryResponse } from '../core/QueryResponseProvider'
// import { useListView } from '../core/ListViewProvider'
// import { errorToast, successToast } from '../../../../../../_metronic/helpers/components/Toaster'


// interface FacilityItem {
//     facility: string;
//     description: string;
//     image1?: string;
//     image2?: string;
//     image3?: string;
// }
// // Types
// interface SocialMediaLinks {
//     website: string;
//     linkedin: string;
//     x: string;
//     facebook: string;
//     youtubeShowcase: string;
// }

// interface MediaItem {
//     url: string;
//     description: string;
// }

// interface ShowcaseItem {
//     customer: string;
//     description: string;
// }

// interface FacilityItem {
//     facility: string;
//     description: string;
// }

// interface FormValues {
//     socialMedia: SocialMediaLinks;
//     images: MediaItem[];
//     videos: MediaItem[];
//     customers: ShowcaseItem[];
//     facilities: FacilityItem[];
//     sponsor: string;
// }

// interface Customer {
//     id: string;
//     personalDetails: {
//         name: string;
//     };
//     companyDetails?: {  // Add this if it exists in your API
//         name: string;
//     };
//     customerType?: string;
//     totalDepositedQuantity?: number;
//     createdAt?: number;
//     address?: {
//         street?: string;
//         city?: string;
//         state?: string;
//         country?: string;
//         zipCode?: string;  // Add this
//     };
//     kycDocument?: Array<{
//         docType: 'CLIENT_LOGO' | string;
//         docUrl: string;
//         docNumber: string;
//     }>;
// }

// interface ApiResponse {
//     data?: Customer[];
//     totalElements?: number;
// }


// type Props = {
//     isUserLoading: boolean
//     user?: User | any
//     arrayDropdown?: any
// }

// // Validation Schema
// const validationSchema = Yup.object({
//     socialMedia: Yup.object({
//         website: Yup.string().url('Invalid URL'),
//         linkedin: Yup.string().url('Invalid URL'),
//         x: Yup.string().url('Invalid URL'),
//         facebook: Yup.string().url('Invalid URL'),
//         youtubeShowcase: Yup.string().url('Invalid URL'),
//     }),
//     images: Yup.array().of(
//         Yup.object({
//             description: Yup.string()
//                 .test('word-count', 'Max 50 words', function (value) {
//                     if (!value) return true;
//                     const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
//                     return wordCount <= 50;
//                 }),
//         })
//     ),
//     videos: Yup.array().of(
//         Yup.object({
//             description: Yup.string()
//                 .test('word-count', 'Max 50 words', function (value) {
//                     if (!value) return true;
//                     const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
//                     return wordCount <= 50;
//                 }),
//         })
//     ),
//     customers: Yup.array().of(
//         Yup.object({
//             customer: Yup.string().required('Customer is required'),
//             description: Yup.string()
//                 .test('word-count', 'Max 50 words', function (value) {
//                     if (!value) return true;
//                     const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
//                     return wordCount <= 50;
//                 }),
//         })
//     ),
//     facilities: Yup.array().of(
//         Yup.object({
//             facility: Yup.string().required('Facility is required'),
//             description: Yup.string()
//                 .test('word-count', 'Max 50 words', function (value) {
//                     if (!value) return true;
//                     const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
//                     return wordCount <= 50;
//                 }),
//         })
//     ),
//     sponsor: Yup.string(),
// });





// const ShowcaseForm: FC<Props> = ({
//     user = {},
//     isUserLoading = false,
//     arrayDropdown = [],
// }) => {


//     console.log("user is .....................", user)
//     const { setItemIdForUpdate } = useListView()
//     const { refetch } = useQueryResponse()
//     const cancel = (withRefresh?: boolean) => {
//         if (withRefresh) {
//             refetch()
//         }
//         setItemIdForUpdate(undefined)
//     }


//     const [filePreviews, setFilePreviews] = useState<{ [key: string]: string }>({});
//     const [customers, setCustomers] = useState<Customer[]>([]);
//     const [loading, setLoading] = useState(false);

//     // Replace your current initialValues with this function
//     const getInitialValues = (): FormValues => {
//         if (!user || Object.keys(user).length === 0) {
//             // Default values for create mode
//             return {
//                 socialMedia: {
//                     website: '',
//                     linkedin: '',
//                     x: '',
//                     facebook: '',
//                     youtubeShowcase: '',
//                 },
//                 images: [{ url: '', description: '' }],
//                 videos: [{ url: '', description: '' }],
//                 customers: [{ customer: '', description: '' }],
//                 facilities: [{ facility: '', description: '', image1: '', image2: '', image3: '' }],
//                 sponsor: '',
//             };
//         }

//         // Extract values from user prop for edit mode
//         const socialMedia = user.social?.[0] || {};

//         return {
//             socialMedia: {
//                 website: socialMedia.website || '',
//                 linkedin: socialMedia.linkedIn || '',
//                 x: socialMedia.twitter || '',
//                 facebook: socialMedia.facebook || '',
//                 youtubeShowcase: socialMedia.ytVideo || '',
//             },
//             images: user.images?.length > 0 ? user.images.map(img => ({
//                 url: img.url || '',
//                 description: img.description || ''
//             })) : [{ url: '', description: '' }],
//             videos: user.videos?.length > 0 ? user.videos.map(vid => ({
//                 url: vid.url || '',
//                 description: vid.description || ''
//             })) : [{ url: '', description: '' }],
//             customers: user.team?.length > 0 ? user.team.map(member => {
//                 // Find customer by name - you'll need to do this after customers are loaded
//                 const customer = customers.find(c => c.personalDetails?.name === member.customerName);
//                 return {
//                     customer: customer?.id || '',
//                     description: member.description || ''
//                 };
//             }) : [{ customer: '', description: '' }],
//             facilities: user.facilityList?.length > 0 ? user.facilityList.map(facility => {
//                 // Find facility by name - you'll need to do this after facilities are loaded
//                 const facilityMatch = facilities.find(f => f.personalDetails?.name === facility.pickupPointName);
//                 return {
//                     facility: facilityMatch?.id || '',
//                     description: facility.description || '',
//                     image1: facility.images?.[0] || '',
//                     image2: facility.images?.[1] || '',
//                     image3: facility.images?.[2] || ''
//                 };
//             }) : [{ facility: '', description: '', image1: '', image2: '', image3: '' }],
//             sponsor: user.sponsorId || '',
//         };
//     };


//     const [facilities, setFacilities] = useState<Customer[]>([]);
//     const [facilitiesLoading, setFacilitiesLoading] = useState(false);

//     // Add this function
//     const fetchFacilities = async () => {
//         try {
//             setFacilitiesLoading(true);

//             const authData = localStorage.getItem('kt-auth-react-v');
//             if (!authData) {
//                 console.error('No authentication token found');
//                 return;
//             }

//             const parsedAuth = JSON.parse(authData);
//             const token = parsedAuth.data?.token;

//             if (!token) {
//                 console.error('Token not found in authentication data');
//                 return;
//             }

//             const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users?page=0&size=10&type=PICKUP_POINT`, {
//                 method: 'GET',
//                 headers: {
//                     'Accept': 'application/json',
//                     'Accept-Language': 'en-US,en;q=0.9',
//                     'Authorization': token,
//                     'Connection': 'keep-alive',
//                     'Sec-Fetch-Dest': 'empty',
//                     'Sec-Fetch-Mode': 'cors',
//                     'Sec-Fetch-Site': 'cross-site',
//                     'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/128.0.0.0 Safari/537.36',
//                     'sec-ch-ua': '"Chromium";v="128", "Not;A=Brand";v="24", "Google Chrome";v="128"',
//                     'sec-ch-ua-mobile': '?0',
//                     'sec-ch-ua-platform': '"Windows"'
//                 }
//             });

//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }

//             const result = await response.json();
//             setFacilities(result || []);
//         } catch (error) {
//             console.error('Error fetching facilities:', error);
//         } finally {
//             setFacilitiesLoading(false);
//         }
//     };


//     const fetchCustomers = async () => {
//         try {
//             setLoading(true);

//             // Get token from localStorage
//             const authData = localStorage.getItem('kt-auth-react-v');
//             if (!authData) {
//                 console.error('No authentication token found');
//                 return;
//             }

//             const parsedAuth = JSON.parse(authData);
//             const token = parsedAuth.data?.token;

//             if (!token) {
//                 console.error('Token not found in authentication data');
//                 return;
//             }

//             const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users?page=1&size=10&type=CUSTOMER`, {
//                 method: 'GET',
//                 headers: {
//                     'Accept': 'application/json',
//                     'Accept-Language': 'en-US,en;q=0.9',
//                     'Authorization': token,
//                     'Connection': 'keep-alive',
//                     'Sec-Fetch-Dest': 'empty',
//                     'Sec-Fetch-Mode': 'cors',
//                     'Sec-Fetch-Site': 'cross-site',
//                     'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/128.0.0.0 Safari/537.36',
//                     'sec-ch-ua': '"Chromium";v="128", "Not;A=Brand";v="24", "Google Chrome";v="128"',
//                     'sec-ch-ua-mobile': '?0',
//                     'sec-ch-ua-platform': '"Windows"'
//                 }
//             });

//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }

//             const result = await response.json(); // This is directly an array, not wrapped in data
//             console.log('API Response:', result); // Add this for debugging
//             setCustomers(result || []); // Use result directly, not result.data
//         } catch (error) {
//             console.error('Error fetching customers:', error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const [sponsors, setSponsors] = useState<Customer[]>([]);
//     const [sponsorsLoading, setSponsorsLoading] = useState(false);

//     // Add this function
//     const fetchSponsors = async () => {
//         try {
//             setSponsorsLoading(true);

//             const authData = localStorage.getItem('kt-auth-react-v');
//             if (!authData) {
//                 console.error('No authentication token found');
//                 return;
//             }

//             const parsedAuth = JSON.parse(authData);
//             const token = parsedAuth.data?.token;

//             if (!token) {
//                 console.error('Token not found in authentication data');
//                 return;
//             }

//             const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users?page=1&size=10&type=SPONSOR`, {
//                 method: 'GET',
//                 headers: {
//                     'Accept': 'application/json',
//                     'Accept-Language': 'en-US,en;q=0.9',
//                     'Authorization': token,
//                     'Connection': 'keep-alive',
//                     'Sec-Fetch-Dest': 'empty',
//                     'Sec-Fetch-Mode': 'cors',
//                     'Sec-Fetch-Site': 'cross-site',
//                     'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/128.0.0.0 Safari/537.36',
//                     'sec-ch-ua': '"Chromium";v="128", "Not;A=Brand";v="24", "Google Chrome";v="128"',
//                     'sec-ch-ua-mobile': '?0',
//                     'sec-ch-ua-platform': '"Windows"'
//                 }
//             });

//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }

//             const result = await response.json();
//             setSponsors(result || []);
//         } catch (error) {
//             console.error('Error fetching sponsors:', error);
//         } finally {
//             setSponsorsLoading(false);
//         }
//     };

//     // Add this to useEffect
//     useEffect(() => {
//         fetchCustomers();
//         fetchFacilities();
//         fetchSponsors(); // Add this line
//     }, []);

//     const handleFileChange = (
//         event: React.ChangeEvent<HTMLInputElement>,
//         setFieldValue: any,
//         fieldName: string,
//         index: number
//     ) => {
//         const file = event.target.files?.[0] || null;
//         setFieldValue(`${fieldName}[${index}].file`, file);

//         // Create preview URL
//         if (file) {
//             const previewUrl = URL.createObjectURL(file);
//             setFilePreviews(prev => ({
//                 ...prev,
//                 [`${fieldName}_${index}`]: previewUrl
//             }));
//         } else {
//             setFilePreviews(prev => {
//                 const newPreviews = { ...prev };
//                 delete newPreviews[`${fieldName}_${index}`];
//                 return newPreviews;
//             });
//         }
//     };

//     // Cleanup function to revoke object URLs
//     useEffect(() => {
//         return () => {
//             Object.values(filePreviews).forEach(url => {
//                 URL.revokeObjectURL(url);
//             });
//         };
//     }, [filePreviews]);


//     const handleSubmit = async (values: FormValues) => {
//         try {
//             setLoading(true);

//             // Get token from localStorage
//             const authData = localStorage.getItem('kt-auth-react-v');
//             if (!authData) {
//                 console.error('No authentication token found');
//                 alert('Authentication token not found. Please login again.');
//                 return;
//             }

//             const parsedAuth = JSON.parse(authData);
//             const token = parsedAuth.data?.token;

//             if (!token) {
//                 console.error('Token not found in authentication data');
//                 alert('Invalid authentication data. Please login again.');
//                 return;
//             }

//             const imageUrls = values.images.filter(img => img.url).map(img => ({
//                 url: img.url,
//                 description: img.description || ""
//             }));

//             const videoUrls = values.videos.filter(vid => vid.url).map(vid => ({
//                 url: vid.url,
//                 description: vid.description || ""
//             }));

//             // Convert form data to API payload format
//             const payload = {
//                 social: [{
//                     linkedIn: values.socialMedia.linkedin || "",
//                     twitter: values.socialMedia.x || "",
//                     facebook: values.socialMedia.facebook || "",
//                     website: values.socialMedia.website || "",
//                     ytVideo: values.socialMedia.youtubeShowcase || ""
//                 }],

//                 team: values.customers.map(customer => {
//                     const selectedCustomer = customers.find(c => c.id === customer.customer);
//                     if (!selectedCustomer) {
//                         return {
//                             // customerId: selectedCustomer.id, // Add this line
//                             customerName: "",
//                             address: "",
//                             profile: "",
//                             quantity: 1.0,
//                             joiningDate: new Date().toISOString(),
//                             description: customer.description || ""
//                         };
//                     }

//                     return {
//                         customerId: selectedCustomer.id,
//                         customerName: selectedCustomer.personalDetails?.name || "",
//                         address: "",
//                         profile: selectedCustomer.customerType || "",
//                         quantity: selectedCustomer.totalDepositedQuantity || 1.0,
//                         joiningDate: selectedCustomer.createdAt ? new Date(selectedCustomer.createdAt).toISOString() : new Date().toISOString(),
//                         description: customer.description || ""
//                     };
//                 }),

//                 facilityList: values.facilities.map(facility => {
//                     const selectedFacility = facilities.find(f => f.id === facility.facility);
//                     if (!selectedFacility) {
//                         return {
//                             pickupPointName: "",
//                             address: "",
//                             images: [],
//                             description: facility.description || ""
//                         };
//                     }

//                     const addressParts: string[] = [];
//                     if (selectedFacility.address?.street) addressParts.push(selectedFacility.address.street);
//                     if (selectedFacility.address?.city) addressParts.push(selectedFacility.address.city);
//                     if (selectedFacility.address?.state) addressParts.push(selectedFacility.address.state);
//                     if (selectedFacility.address?.country) addressParts.push(selectedFacility.address.country);
//                     if (selectedFacility.address?.zipCode) addressParts.push(selectedFacility.address.zipCode);

//                     const facilityImages: string[] = [];
//                     if (facility.image1) facilityImages.push(facility.image1);
//                     if (facility.image2) facilityImages.push(facility.image2);
//                     if (facility.image3) facilityImages.push(facility.image3);

//                     return {
//                         pickupPointId: selectedFacility.id,
//                         pickupPointName: selectedFacility.personalDetails?.name || "",
//                         address: addressParts.join(", "),
//                         images: facilityImages,

//                         description: facility.description || ""
//                     };
//                 }),

//                 images: imageUrls.filter(img => img.url),
//                 videos: videoUrls.filter(vid => vid.url),
//                 sponsorId: values.sponsor
//             };

//             console.log('Payload being sent:', payload);

//             // Determine if it's edit mode based on user having an id
//             const isEditMode = user && user.id;
//             const apiUrl = isEditMode
//                 ? `${process.env.REACT_APP_BASE_API_URL}engagement/${user.id}/update`
//                 : `${process.env.REACT_APP_BASE_API_URL}engagement`;

//             const method = isEditMode ? 'PUT' : 'POST';

//             console.log(`Making ${method} request to:`, apiUrl);

//             const response = await fetch(apiUrl, {
//                 method: method,
//                 headers: {
//                     'Authorization': token,
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify(payload)
//             });

//             if (!response.ok) {
//                 const errorData = await response.text();
//                 throw new Error(`HTTP error! status: ${response.status}, message: ${errorData}`);
//             }

//             const result = await response.json();
//             console.log(`Form ${isEditMode ? 'updated' : 'submitted'} successfully:`, result);

//             // Success handling with toast
//             successToast(`${isEditMode ? 'Updated' : 'Added'} successfully!`);
//             window.location.reload();

//         } catch (error) {
//             console.error(`Error ${user && user.id ? 'updating' : 'submitting'} form:`, error);
//             // alert(`Error ${user && user.id ? 'updating' : 'submitting'} form: ${error.message}`);
//         } finally {
//             setLoading(false);
//         }
//     };



//     // Keep your default initialValues
//     const initialValues: FormValues = {
//         socialMedia: {
//             website: '',
//             linkedin: '',
//             x: '',
//             facebook: '',
//             youtubeShowcase: '',
//         },
//         images: [{ url: '', description: '' }],
//         videos: [{ url: '', description: '' }],
//         customers: [{ customer: '', description: '' }],
//         facilities: [{ facility: '', description: '', image1: '', image2: '', image3: '' }],
//         sponsor: '',
//     };

//     // Add state for dynamic initial values
//     const [dynamicInitialValues, setDynamicInitialValues] = useState<FormValues>(initialValues);

//     // Add this useEffect to update initial values when data is loaded
//     // Updated useEffect with better condition
//     useEffect(() => {
//         if (user && Object.keys(user).length > 0) {
//             const socialMedia = user.social?.[0] || {};

//             const transformedValues: FormValues = {
//                 socialMedia: {
//                     website: socialMedia.website || '',
//                     linkedin: socialMedia.linkedIn || '',
//                     x: socialMedia.twitter || '',
//                     facebook: socialMedia.facebook || '',
//                     youtubeShowcase: socialMedia.ytVideo || '',
//                 },
//                 images: user.images?.length > 0 ? user.images.map(img => ({
//                     url: img.url || '',
//                     description: img.description || ''
//                 })) : [{ url: '', description: '' }],
//                 videos: user.videos?.length > 0 ? user.videos.map(vid => ({
//                     url: vid.url || '',
//                     description: vid.description || ''
//                 })) : [{ url: '', description: '' }],
//                 customers: user.team?.length > 0 ? user.team.map(member => {
//                     const customer = customers.find(c => c.personalDetails?.name === member.customerName);
//                     return {
//                         customer: customer?.id || '',
//                         description: member.description || ''
//                     };
//                 }) : [{ customer: '', description: '' }],
//                 facilities: user.facilityList?.length > 0 ? user.facilityList.map(facility => {
//                     const facilityMatch = facilities.find(f => f.personalDetails?.name === facility.pickupPointName);
//                     return {
//                         facility: facilityMatch?.id || '',
//                         description: facility.description || '',
//                         image1: facility.images?.[0] || '',
//                         image2: facility.images?.[1] || '',
//                         image3: facility.images?.[2] || ''
//                     };
//                 }) : [{ facility: '', description: '', image1: '', image2: '', image3: '' }],
//                 sponsor: user.sponsorId || '',
//             };

//             setDynamicInitialValues(transformedValues);
//         }
//     }, [user, customers, facilities, sponsors]);



//     return (
//         <div className="max-w-4xl mx-auto p-6 bg-white">
//             <Formik
//                 initialValues={dynamicInitialValues}
//                 validationSchema={validationSchema}
//                 onSubmit={handleSubmit}
//                 enableReinitialize={true}
//             >
//                 {({ values, setFieldValue, ...formikProps }) => (
//                     <Form className="space-y-8">




//                         {/* Select Sponsor */}
//                         {/* <div>
//                             <label className="block text-sm font-medium mb-1">Select Sponsor</label>
//                             <Field
//                                 name="sponsor"
//                                 as="select"
//                                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                             >
//                                 <option value="">
//                                     {sponsorsLoading ? 'Loading sponsors...' : 'Choose a sponsor'}
//                                 </option>
//                                 {sponsors.map((sponsor) => (
//                                     <option key={sponsor.id} value={sponsor.id}>
//                                         {sponsor.companyDetails?.name || 'Unnamed Sponsor'}
//                                     </option>
//                                 ))}
//                             </Field>
//                             <ErrorMessage name="sponsor" component="div" className="text-red-500 text-sm mt-1" />
//                         </div> */}


//                         <div>
//                             <label className='required fw-bold fs-6 mb-2'>Select Sponsor</label>
//                             <div className="relative">
//                                 {/* <Field
//                                     name="sponsor"
//                                     as="select"
//                                     className="w-full pl-12 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                 >
//                                     <option value="">
//                                         {sponsorsLoading ? 'Loading sponsors...' : 'Choose a sponsor'}
//                                     </option>
//                                     {sponsors.map((sponsor) => {

//                                         const logoUrl = sponsor.kycDocument?.find(doc => doc.docType === 'CLIENT_LOGO')?.docUrl;

//                                         return (
//                                             <option key={sponsor.id} value={sponsor.id}>
//                                                 {sponsor.companyDetails?.name || 'Unnamed Sponsor'}
//                                             </option>
//                                         );
//                                     })}
//                                 </Field> */}


//                                 <Field
//                                     name="sponsor"
//                                     as="select"
//                                     style={{
//                                         backgroundColor: '#ffffff',
//                                         border: '1px solid #dddddd',
//                                         color: '#000000',
//                                         paddingLeft: '40px', // Add left padding for the image
//                                     }}
//                                     className="form-control form-control-solid mb-3 mb-lg-0"
//                                     // disabled={isSubmitting || isUserLoading}
//                                 >
//                                     <option value="">
//                                         {sponsorsLoading ? 'Loading sponsors...' : 'Choose a sponsor'}
//                                     </option>
//                                     {sponsors.map((sponsor) => {
//                                         const logoUrl = sponsor.kycDocument?.find(doc => doc.docType === 'CLIENT_LOGO')?.docUrl;
//                                         return (
//                                             <option key={sponsor.id} value={sponsor.id}>
//                                                 {sponsor.companyDetails?.name || 'Unnamed Sponsor'}
//                                             </option>
//                                         );
//                                     })}
//                                 </Field>

//                                 {/* Show image for selected sponsor */}
//                                 <div className="absolute inset-y-0 left-0 flex items-center pl-3">
//                                     {(() => {
//                                         const selectedSponsor = sponsors.find(s => s.id === values.sponsor);
//                                         const logoUrl = selectedSponsor?.kycDocument?.find(doc => doc.docType === 'CLIENT_LOGO')?.docUrl;

//                                         return logoUrl ? (
//                                             <img
//                                                 src={logoUrl}
//                                                 alt="Sponsor Logo"
//                                                 className="w-6 h-6 rounded-full object-cover"
//                                             />
//                                         ) : (
//                                             <div className="w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center">
//                                                 <span className="text-xs text-gray-500">?</span>
//                                             </div>
//                                         );
//                                     })()}
//                                 </div>
//                             </div>
//                             <ErrorMessage name="sponsor" component="div" className="text-red-500 text-sm mt-1" />
//                         </div>


//                         {/* Social Media Links */}
//                         <div>
//                             <h2 className="text-xl font-semibold mb-4">Social Media Links</h2>
//                             {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                                 <div>
//                                     <label className='required fw-bold fs-6 mb-2'>Website</label>
//                                     <div className="relative">
//                                         <div className="absolute inset-y-0 left-0 flex items-center pl-3">
//                                             <img
//                                                 src="/website.jpg"
//                                                 alt="Website"
//                                                 className="w-5 h-5"
//                                             />
//                                         </div>
//                                         <Field
//                                             name="socialMedia.website"
//                                             type="url"
//                                             className="w-full pl-12 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                             placeholder="https://example.com"
//                                         />
//                                     </div>
//                                     <ErrorMessage name="socialMedia.website" component="div" className="text-red-500 text-sm mt-1" />
//                                 </div>

//                                 <div>
//                                     <label className="block text-sm font-medium mb-1">LinkedIn</label>
//                                     <div className="relative">
//                                         <div className="absolute inset-y-0 left-0 flex items-center pl-3">
//                                             <img
//                                                 src="/linkedin.png"
//                                                 alt="LinkedIn"
//                                                 className="w-5 h-5"
//                                             />
//                                         </div>
//                                         <Field
//                                             name="socialMedia.linkedin"
//                                             type="url"
//                                             className="w-full pl-12 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                             placeholder="https://linkedin.com/in/username"
//                                         />
//                                     </div>
//                                     <ErrorMessage name="socialMedia.linkedin" component="div" className="text-red-500 text-sm mt-1" />
//                                 </div>

//                                 <div>
//                                     <label className="block text-sm font-medium mb-1">X</label>
//                                     <div className="relative">
//                                         <div className="absolute inset-y-0 left-0 flex items-center pl-3">
//                                             <img
//                                                 src="/twitter.png"
//                                                 alt="X"
//                                                 className="w-5 h-5"
//                                             />
//                                         </div>
//                                         <Field
//                                             name="socialMedia.x"
//                                             type="url"
//                                             className="w-full pl-12 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                             placeholder="https://x.com/username"
//                                         />
//                                     </div>
//                                     <ErrorMessage name="socialMedia.x" component="div" className="text-red-500 text-sm mt-1" />
//                                 </div>

//                                 <div>
//                                     <label className="block text-sm font-medium mb-1">Facebook</label>
//                                     <div className="relative">
//                                         <div className="absolute inset-y-0 left-0 flex items-center pl-3">
//                                             <img
//                                                 src="/facebook.png"
//                                                 alt="Facebook"
//                                                 className="w-5 h-5"
//                                             />
//                                         </div>
//                                         <Field
//                                             name="socialMedia.facebook"
//                                             type="url"
//                                             className="w-full pl-12 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                             placeholder="https://facebook.com/username"
//                                         />
//                                     </div>
//                                     <ErrorMessage name="socialMedia.facebook" component="div" className="text-red-500 text-sm mt-1" />
//                                 </div>

//                                 <div>
//                                     <label className="block text-sm font-medium mb-1">YouTube Showcase</label>
//                                     <div className="relative">
//                                         <div className="absolute inset-y-0 left-0 flex items-center pl-3">
//                                             <img
//                                                 src="/youtube.png"
//                                                 alt="YouTube"
//                                                 className="w-5 h-5"
//                                             />
//                                         </div>
//                                         <Field
//                                             name="socialMedia.youtubeShowcase"
//                                             type="url"
//                                             className="w-full pl-12 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                             placeholder="https://youtube.com/watch?v=..."
//                                         />
//                                     </div>
//                                     <ErrorMessage name="socialMedia.youtubeShowcase" component="div" className="text-red-500 text-sm mt-1" />
//                                 </div>
//                             </div> */}

//                             <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                                 <div>
//                                     <label className='required fw-bold fs-6 mb-2'>Website</label>
//                                     <div className="relative">
//                                         <div className="absolute inset-y-0 left-0 flex items-center pl-3">
//                                             <img
//                                                 src="/website.jpg"
//                                                 alt="Website"
//                                                 className="w-5 h-5"
//                                             />
//                                         </div>
//                                         <Field
//                                             name="socialMedia.website"
//                                             type="url"
//                                             style={{
//                                                 backgroundColor: '#ffffff',
//                                                 border: '1px solid #dddddd',
//                                                 color: '#000000',
//                                                 paddingLeft: '40px',
//                                             }}
//                                             className="form-control form-control-solid mb-3 mb-lg-0"
//                                             placeholder="https://example.com"
//                                             autoComplete='off'
//                                         />
//                                     </div>
//                                     <ErrorMessage name="socialMedia.website" component="div" className="text-red-500 text-sm mt-1" />
//                                 </div>

//                                 <div>
//                                     <label className='required fw-bold fs-6 mb-2'>LinkedIn</label>
//                                     <div className="relative">
//                                         <div className="absolute inset-y-0 left-0 flex items-center pl-3">
//                                             <img
//                                                 src="/linkedin.png"
//                                                 alt="LinkedIn"
//                                                 className="w-5 h-5"
//                                             />
//                                         </div>
//                                         <Field
//                                             name="socialMedia.linkedin"
//                                             type="url"
//                                             style={{
//                                                 backgroundColor: '#ffffff',
//                                                 border: '1px solid #dddddd',
//                                                 color: '#000000',
//                                                 paddingLeft: '40px',
//                                             }}
//                                             className="form-control form-control-solid mb-3 mb-lg-0"
//                                             placeholder="https://linkedin.com/in/username"
//                                             autoComplete='off'
//                                         />
//                                     </div>
//                                     <ErrorMessage name="socialMedia.linkedin" component="div" className="text-red-500 text-sm mt-1" />
//                                 </div>

//                                 <div>
//                                     <label className='required fw-bold fs-6 mb-2'>X</label>
//                                     <div className="relative">
//                                         <div className="absolute inset-y-0 left-0 flex items-center pl-3">
//                                             <img
//                                                 src="/twitter.png"
//                                                 alt="X"
//                                                 className="w-5 h-5"
//                                             />
//                                         </div>
//                                         <Field
//                                             name="socialMedia.x"
//                                             type="url"
//                                             style={{
//                                                 backgroundColor: '#ffffff',
//                                                 border: '1px solid #dddddd',
//                                                 color: '#000000',
//                                                 paddingLeft: '40px',
//                                             }}
//                                             className="form-control form-control-solid mb-3 mb-lg-0"
//                                             placeholder="https://x.com/username"
//                                             autoComplete='off'
//                                         />
//                                     </div>
//                                     <ErrorMessage name="socialMedia.x" component="div" className="text-red-500 text-sm mt-1" />
//                                 </div>

//                                 <div>
//                                     <label className='required fw-bold fs-6 mb-2'>Facebook</label>
//                                     <div className="relative">
//                                         <div className="absolute inset-y-0 left-0 flex items-center pl-3">
//                                             <img
//                                                 src="/facebook.png"
//                                                 alt="Facebook"
//                                                 className="w-5 h-5"
//                                             />
//                                         </div>
//                                         <Field
//                                             name="socialMedia.facebook"
//                                             type="url"
//                                             style={{
//                                                 backgroundColor: '#ffffff',
//                                                 border: '1px solid #dddddd',
//                                                 color: '#000000',
//                                                 paddingLeft: '40px',
//                                             }}
//                                             className="form-control form-control-solid mb-3 mb-lg-0"
//                                             placeholder="https://facebook.com/username"
//                                             autoComplete='off'
//                                         />
//                                     </div>
//                                     <ErrorMessage name="socialMedia.facebook" component="div" className="text-red-500 text-sm mt-1" />
//                                 </div>

//                                 <div>
//                                     <label className='required fw-bold fs-6 mb-2'>YouTube Showcase</label>
//                                     <div className="relative">
//                                         <div className="absolute inset-y-0 left-0 flex items-center pl-3">
//                                             <img
//                                                 src="/youtube.png"
//                                                 alt="YouTube"
//                                                 className="w-5 h-5"
//                                             />
//                                         </div>
//                                         <Field
//                                             name="socialMedia.youtubeShowcase"
//                                             type="url"
//                                             style={{
//                                                 backgroundColor: '#ffffff',
//                                                 border: '1px solid #dddddd',
//                                                 color: '#000000',
//                                                 paddingLeft: '40px',
//                                             }}
//                                             className="form-control form-control-solid mb-3 mb-lg-0"
//                                             placeholder="https://youtube.com/watch?v=..."
//                                             autoComplete='off'
//                                         />
//                                     </div>
//                                     <ErrorMessage name="socialMedia.youtubeShowcase" component="div" className="text-red-500 text-sm mt-1" />
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Images Section */}
//                         {/* <div>
//                             <h2 className="text-xl font-semibold mb-4">
//                                 Showcase any special event/initiative
//                             </h2>
//                             <FieldArray name="images">
//                                 {({ push, remove }) => (
//                                     <div className="space-y-4">
//                                         {values.images.map((_, index) => (
//                                             <div key={index} className="flex items-start gap-4">
//                                                 <div>
//                                                     <div className="relative">
//                                                         <div className="flex-shrink-0">
//                                                             <UploadImage
//                                                                 name={`images[${index}].url`}
//                                                                 formik={{ ...formikProps, values, setFieldValue }}
//                                                                 label="Upload image"
//                                                                 required={false}
//                                                             />
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="flex-1">
//                                                     <label className="block text-sm font-medium mb-1">Description</label>

//                                                     <Field name={`images[${index}].description`}>
//                                                         {({ field, form }) => {
//                                                             const wordCount = field.value ? field.value.trim().split(/\s+/).filter(word => word.length > 0).length : 0;

//                                                             return (
//                                                                 <div>
//                                                                     <textarea
//                                                                         {...field}
//                                                                         rows={6}
//                                                                         className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                                         style={{ resize: 'none' }}
//                                                                         placeholder="Max 50 words"
//                                                                         onChange={(e) => {
//                                                                             const words = e.target.value.trim().split(/\s+/).filter(word => word.length > 0);
//                                                                             if (words.length <= 50 || e.target.value === '') {
//                                                                                 form.setFieldValue(field.name, e.target.value);
//                                                                             }
//                                                                         }}
//                                                                     />
//                                                                     <div className={`text-sm mt-1 ${wordCount > 50 ? 'text-red-500' : 'text-gray-500'}`}>
//                                                                         {wordCount}/50 words
//                                                                     </div>
//                                                                 </div>
//                                                             );
//                                                         }}
//                                                     </Field>
//                                                     <ErrorMessage name={`images[${index}].description`} component="div" className="text-red-500 text-sm mt-1" />
//                                                 </div>
//                                                 <button
//                                                     type="button"
//                                                     onClick={() => push({ file: null, description: '' })}
//                                                     className="px-4 py-2 text-white rounded-md hover:opacity-80 text-sm"
//                                                     style={{ backgroundColor: '#0095e8' }}
//                                                 >
//                                                     Add more
//                                                 </button>
//                                                 {index > 0 && (
//                                                     <button
//                                                         type="button"
//                                                         onClick={() => remove(index)}
//                                                         className="px-4 py-2 text-red-500 rounded-md hover:bg-red-50 text-sm flex items-center justify-center"
//                                                     >
//                                                         <KTIcon iconName='trash' className='fs-3' />
//                                                     </button>
//                                                 )}
//                                             </div>
//                                         ))}
//                                     </div>
//                                 )}
//                             </FieldArray>
//                         </div> */}


//                         <div>
//                             <h2 className="text-xl font-semibold mb-4">
//                                 Showcase any special event/initiative
//                             </h2>
//                             <FieldArray name="images">
//                                 {({ push, remove }) => (
//                                     <div className="">
//                                         {values.images.map((_, index) => (
//                                             <div key={index}>
//                                                 <div className="flex items-start gap-3">
//                                                     <div className="flex-shrink-0">
//                                                         <UploadImage
//                                                             name={`images[${index}].url`}
//                                                             formik={{ ...formikProps, values, setFieldValue }}
//                                                             label="Upload image"
//                                                             required={false}
//                                                         />
//                                                     </div>
//                                                     <div className="flex-1 relative">
//                                                         <label className='required fw-bold fs-6 mb-2'>Description</label>
//                                                         <Field name={`images[${index}].description`}>
//                                                             {({ field, form }) => {
//                                                                 const wordCount = field.value ? field.value.trim().split(/\s+/).filter(word => word.length > 0).length : 0;

//                                                                 return (
//                                                                     <div>
//                                                                         <textarea
//                                                                             {...field}
//                                                                             rows={4}
//                                                                             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                                             style={{ resize: 'none' }}
//                                                                             placeholder="Max 50 words"
//                                                                             onChange={(e) => {
//                                                                                 const words = e.target.value.trim().split(/\s+/).filter(word => word.length > 0);
//                                                                                 if (words.length <= 50 || e.target.value === '') {
//                                                                                     form.setFieldValue(field.name, e.target.value);
//                                                                                 }
//                                                                             }}
//                                                                         />
//                                                                         <div className={`text-sm mt-1 ${wordCount > 50 ? 'text-red-500' : 'text-gray-500'}`}>
//                                                                             {wordCount}/50 words
//                                                                         </div>
//                                                                     </div>
//                                                                 );
//                                                             }}
//                                                         </Field>
//                                                         <ErrorMessage name={`images[${index}].description`} component="div" className="text-red-500 text-sm mt-1" />
//                                                         <button
//                                                             type="button"
//                                                             onClick={() => push({ file: null, description: '' })}
//                                                             className="absolute -right-12 top-8 flex items-center justify-center w-10 h-10 text-white rounded-full hover:opacity-80"
//                                                             style={{ backgroundColor: '#0095e8' }}
//                                                         >
//                                                             <span className="text-xl font-bold">+</span>
//                                                         </button>
//                                                         {index > 0 && (
//                                                             <button
//                                                                 type="button"
//                                                                 onClick={() => remove(index)}
//                                                                 className="absolute -right-12 top-16 p-2 text-red-500 rounded-md hover:bg-red-50 flex items-center justify-center mt-4"
//                                                             >
//                                                                 <KTIcon iconName='trash' className='fs-3' />
//                                                             </button>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 )}
//                             </FieldArray>
//                         </div>

//                         {/* Videos Section */}
//                         {/* <div>
//                             <h2 className="text-xl font-semibold mb-4">Showcase any special event/initiative</h2>
//                             <FieldArray name="videos">
//                                 {({ push, remove }) => (
//                                     <div className="space-y-4">
//                                         {values.videos.map((_, index) => (
//                                             <div key={index} className="flex items-start gap-4">
//                                                 <div>
//                                                     <div className="relative">
//                                                         <div className="flex-shrink-0">
//                                                             <UploadVideo
//                                                                 name={`videos[${index}].url`}
//                                                                 formik={{ ...formikProps, values, setFieldValue }}
//                                                                 label="Upload Video"
//                                                                 required={false}
//                                                             />
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="flex-1">
//                                                     <label className="block text-sm font-medium mb-1">Description</label>
//                                                     <Field name={`videos[${index}].description`}>
//                                                         {({ field, form }) => {
//                                                             const wordCount = field.value ? field.value.trim().split(/\s+/).filter(word => word.length > 0).length : 0;

//                                                             return (
//                                                                 <div>
//                                                                     <textarea
//                                                                         {...field}
//                                                                         rows={6}
//                                                                         className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                                         style={{ resize: 'none' }}
//                                                                         placeholder="Max 50 words"
//                                                                         onChange={(e) => {
//                                                                             const words = e.target.value.trim().split(/\s+/).filter(word => word.length > 0);
//                                                                             if (words.length <= 50 || e.target.value === '') {
//                                                                                 form.setFieldValue(field.name, e.target.value);
//                                                                             }
//                                                                         }}
//                                                                     />
//                                                                     <div className={`text-sm mt-1 ${wordCount > 50 ? 'text-red-500' : 'text-gray-500'}`}>
//                                                                         {wordCount}/50 words
//                                                                     </div>
//                                                                 </div>
//                                                             );
//                                                         }}
//                                                     </Field>
//                                                     <ErrorMessage name={`videos[${index}].description`} component="div" className="text-red-500 text-sm mt-1" />
//                                                 </div>
//                                                 <button
//                                                     type="button"
//                                                     onClick={() => push({ file: null, description: '' })}
//                                                     className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm"
//                                                 >
//                                                     Add more
//                                                 </button>
//                                                 {index > 0 && (
//                                                     <button
//                                                         type="button"
//                                                         onClick={() => remove(index)}
//                                                         className="px-4 py-2 text-red-500 rounded-md hover:bg-red-50 text-sm flex items-center justify-center"
//                                                     >
//                                                         <KTIcon iconName='trash' className='fs-3' />
//                                                     </button>
//                                                 )}
//                                             </div>
//                                         ))}
//                                     </div>
//                                 )}
//                             </FieldArray>
//                         </div> */}


//                         <div style={{ marginTop: "-20px" }}>
//                             <h2 className="text-xl font-semibold mb-4">Showcase any special event/initiative</h2>
//                             <FieldArray name="videos">
//                                 {({ push, remove }) => (
//                                     <div className="" >
//                                         {values.videos.map((_, index) => (
//                                             <div key={index}>
//                                                 <div className="flex items-start gap-3">
//                                                     <div className="flex-shrink-0">
//                                                         <UploadVideo
//                                                             name={`videos[${index}].url`}
//                                                             formik={{ ...formikProps, values, setFieldValue }}
//                                                             label="Upload Video"
//                                                             required={false}
//                                                         />
//                                                     </div>
//                                                     <div className="flex-1 relative">
//                                                         <label className='required fw-bold fs-6 mb-2'>Description</label>
//                                                         <Field name={`videos[${index}].description`}>
//                                                             {({ field, form }) => {
//                                                                 const wordCount = field.value ? field.value.trim().split(/\s+/).filter(word => word.length > 0).length : 0;

//                                                                 return (
//                                                                     <div>
//                                                                         <textarea
//                                                                             {...field}
//                                                                             rows={4}
//                                                                             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                                             style={{ resize: 'none' }}
//                                                                             placeholder="Max 50 words"
//                                                                             onChange={(e) => {
//                                                                                 const words = e.target.value.trim().split(/\s+/).filter(word => word.length > 0);
//                                                                                 if (words.length <= 50 || e.target.value === '') {
//                                                                                     form.setFieldValue(field.name, e.target.value);
//                                                                                 }
//                                                                             }}
//                                                                         />
//                                                                         <div className={`text-sm mt-1 ${wordCount > 50 ? 'text-red-500' : 'text-gray-500'}`}>
//                                                                             {wordCount}/50 words
//                                                                         </div>
//                                                                     </div>
//                                                                 );
//                                                             }}
//                                                         </Field>
//                                                         <ErrorMessage name={`videos[${index}].description`} component="div" className="text-red-500 text-sm mt-1" />
//                                                         <button
//                                                             type="button"
//                                                             onClick={() => push({ file: null, description: '' })}
//                                                             className="absolute -right-12 top-8 flex items-center justify-center w-10 h-10 text-white rounded-full hover:opacity-80"
//                                                             style={{ backgroundColor: '#0095e8' }}
//                                                         >
//                                                             <span className="text-xl font-bold">+</span>
//                                                         </button>
//                                                         {index > 0 && (
//                                                             <button
//                                                                 type="button"
//                                                                 onClick={() => remove(index)}
//                                                                 className="absolute -right-12 top-16 p-2 text-red-500 rounded-md hover:bg-red-50 flex items-center justify-center mt-5"
//                                                             >
//                                                                 <KTIcon iconName='trash' className='fs-3' />
//                                                             </button>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 )}
//                             </FieldArray>
//                         </div>

//                         {/* Showcase your customers */}
//                         {/* <div>
//                             <h2 className="text-xl font-semibold mb-4">Showcase your collectors</h2>
//                             <FieldArray name="customers">
//                                 {({ push, remove }) => (
//                                     <div className="space-y-4">
//                                         {values.customers.map((_, index) => (
//                                             <div key={index} className="flex items-start gap-4">
//                                                 <div className="flex-1">
//                                                     <label className="block text-sm font-medium mb-1">Select Customer</label>
//                                                     <Field
//                                                         name={`customers[${index}].customer`}
//                                                         as="select"
//                                                         className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                     >
//                                                         <option value="">
//                                                             {loading ? 'Loading customers...' : 'Choose a customer'}
//                                                         </option>
//                                                         {customers.map((customer) => (
//                                                             <option key={customer.id} value={customer.id}>
//                                                                 {customer.personalDetails?.name || 'Unnamed Customer'}
//                                                             </option>
//                                                         ))}
//                                                     </Field>
//                                                     <ErrorMessage name={`customers[${index}].customer`} component="div" className="text-red-500 text-sm mt-1" />
//                                                 </div>
//                                                 <div className="flex-1">
//                                                     <label className="block text-sm font-medium mb-1">Add Description</label>
//                                                     <Field name={`customers[${index}].description`}>
//                                                         {({ field, form }) => {
//                                                             const wordCount = field.value ? field.value.trim().split(/\s+/).filter(word => word.length > 0).length : 0;

//                                                             return (
//                                                                 <div>
//                                                                     <textarea
//                                                                         {...field}
//                                                                         rows={6}
//                                                                         className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                                         style={{ resize: 'none' }}
//                                                                         placeholder="Max 50 words"
//                                                                         onChange={(e) => {
//                                                                             const words = e.target.value.trim().split(/\s+/).filter(word => word.length > 0);
//                                                                             if (words.length <= 50 || e.target.value === '') {
//                                                                                 form.setFieldValue(field.name, e.target.value);
//                                                                             }
//                                                                         }}
//                                                                     />
//                                                                     <div className={`text-sm mt-1 ${wordCount > 50 ? 'text-red-500' : 'text-gray-500'}`}>
//                                                                         {wordCount}/50 words
//                                                                     </div>
//                                                                 </div>
//                                                             );
//                                                         }}
//                                                     </Field>
//                                                     <ErrorMessage name={`customers[${index}].description`} component="div" className="text-red-500 text-sm mt-1" />
//                                                 </div>
//                                                 <button
//                                                     type="button"
//                                                     onClick={() => push({ customer: '', description: '' })}
//                                                     className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm"
//                                                 >
//                                                     Add more
//                                                 </button>
//                                                 {index > 0 && (
//                                                     <button
//                                                         type="button"
//                                                         onClick={() => remove(index)}
//                                                         className="px-4 py-2 text-red-500 rounded-md hover:bg-red-50 text-sm flex items-center justify-center"
//                                                     >
//                                                         <KTIcon iconName='trash' className='fs-3' />
//                                                     </button>
//                                                 )}
//                                             </div>
//                                         ))}
//                                     </div>
//                                 )}
//                             </FieldArray>
//                         </div> */}
//                         <div style={{ marginTop: "-20px" }}>
//                             <h2 className="text-xl font-semibold mb-4">Showcase your collectors</h2>
//                             <FieldArray name="customers">
//                                 {({ push, remove }) => (
//                                     <div className="space-y-3">
//                                         {values.customers.map((_, index) => (
//                                             <div key={index}>
//                                                 <div className="space-y-3">
//                                                     <div className="relative">
//                                                         <label className='required fw-bold fs-6 mb-2'>Select Waste Collector</label>
//                                                         <Field
//                                                             name={`customers[${index}].customer`}
//                                                             as="select"
//                                                             style={{
//                                                                 backgroundColor: '#ffffff',
//                                                                 border: '1px solid #dddddd',
//                                                                 color: '#000000',
//                                                             }}
//                                                             className="form-control form-control-solid mb-3 mb-lg-0"
//                                                             autoComplete='off'
//                                                         >
//                                                             <option value="">
//                                                                 {loading ? 'Loading customers...' : 'Choose a customer'}
//                                                             </option>
//                                                             {customers.map((customer) => (
//                                                                 <option key={customer.id} value={customer.id}>
//                                                                     {customer.personalDetails?.name || 'Unnamed Customer'}
//                                                                 </option>
//                                                             ))}
//                                                         </Field>
//                                                         <ErrorMessage name={`customers[${index}].customer`} component="div" className="text-red-500 text-sm mt-1" />
//                                                     </div>
//                                                     <div className="relative">
//                                                         <label className='required fw-bold fs-6 mb-2'>Add Description</label>
//                                                         <Field name={`customers[${index}].description`}>
//                                                             {({ field, form }) => {
//                                                                 const wordCount = field.value ? field.value.trim().split(/\s+/).filter(word => word.length > 0).length : 0;

//                                                                 return (
//                                                                     <div>
//                                                                         <textarea
//                                                                             {...field}
//                                                                             rows={4}
//                                                                             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                                             style={{ resize: 'none' }}
//                                                                             placeholder="Max 50 words"
//                                                                             onChange={(e) => {
//                                                                                 const words = e.target.value.trim().split(/\s+/).filter(word => word.length > 0);
//                                                                                 if (words.length <= 50 || e.target.value === '') {
//                                                                                     form.setFieldValue(field.name, e.target.value);
//                                                                                 }
//                                                                             }}
//                                                                         />
//                                                                         <div className={`text-sm mt-1 ${wordCount > 50 ? 'text-red-500' : 'text-gray-500'}`}>
//                                                                             {wordCount}/50 words
//                                                                         </div>
//                                                                     </div>
//                                                                 );
//                                                             }}
//                                                         </Field>
//                                                         <ErrorMessage name={`customers[${index}].description`} component="div" className="text-red-500 text-sm mt-1" />
//                                                         <button
//                                                             type="button"
//                                                             onClick={() => push({ customer: '', description: '' })}
//                                                             className="absolute -right-12 top-8 flex items-center justify-center w-10 h-10 text-white rounded-full hover:opacity-80"
//                                                             style={{ backgroundColor: '#0095e8' }}
//                                                         >
//                                                             <span className="text-xl font-bold">+</span>
//                                                         </button>
//                                                         {index > 0 && (
//                                                             <button
//                                                                 type="button"
//                                                                 onClick={() => remove(index)}
//                                                                 className="absolute -right-12 top-16 p-2 text-red-500 rounded-md hover:bg-red-50 flex items-center justify-center mt-5"
//                                                             >
//                                                                 <KTIcon iconName='trash' className='fs-3' />
//                                                             </button>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 )}
//                             </FieldArray>
//                         </div>

//                         {/* Showcase your facility */}
//                         {/* <div>
//                             <h2 className="text-xl font-semibold mb-4">Showcase your facility</h2>
//                             <FieldArray name="facilities">
//                                 {({ push, remove }) => (
//                                     <div className="space-y-4">
//                                         {values.facilities.map((_, index) => (
//                                             <div key={index} className="space-y-4 p-4 border border-gray-200 rounded-lg">

//                                                 <div className="flex items-start gap-4">
//                                                     <div className="flex-1">
//                                                         <label className="block text-sm font-medium mb-1">Select facility</label>
//                                                         <Field
//                                                             name={`facilities[${index}].facility`}
//                                                             as="select"
//                                                             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                         >
//                                                             <option value="">
//                                                                 {facilitiesLoading ? 'Loading facilities...' : 'Choose a facility'}
//                                                             </option>
//                                                             {facilities.map((facility) => (
//                                                                 <option key={facility.id} value={facility.id}>
//                                                                     {facility.personalDetails?.name || 'Unnamed Facility'}
//                                                                 </option>
//                                                             ))}
//                                                         </Field>
//                                                         <ErrorMessage name={`facilities[${index}].facility`} component="div" className="text-red-500 text-sm mt-1" />
//                                                     </div>
//                                                     <div className="flex-1">
//                                                         <label className="block text-sm font-medium mb-1">Add Description</label>
//                                                         <Field name={`facilities[${index}].description`}>
//                                                             {({ field, form }) => {
//                                                                 const wordCount = field.value ? field.value.trim().split(/\s+/).filter(word => word.length > 0).length : 0;

//                                                                 return (
//                                                                     <div>
//                                                                         <textarea
//                                                                             {...field}
//                                                                             rows={6}
//                                                                             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                                             style={{ resize: 'none' }}
//                                                                             placeholder="Max 50 words"
//                                                                             onChange={(e) => {
//                                                                                 const words = e.target.value.trim().split(/\s+/).filter(word => word.length > 0);
//                                                                                 if (words.length <= 50 || e.target.value === '') {
//                                                                                     form.setFieldValue(field.name, e.target.value);
//                                                                                 }
//                                                                             }}
//                                                                         />
//                                                                         <div className={`text-sm mt-1 ${wordCount > 50 ? 'text-red-500' : 'text-gray-500'}`}>
//                                                                             {wordCount}/50 words
//                                                                         </div>
//                                                                     </div>
//                                                                 );
//                                                             }}
//                                                         </Field>
//                                                         <ErrorMessage name={`facilities[${index}].description`} component="div" className="text-red-500 text-sm mt-1" />
//                                                     </div>
//                                                 </div>


//                                                 <div>
//                                                     <label className="block text-sm font-medium mb-2">Facility Images</label>
//                                                     <div className="grid grid-cols-3 gap-4">
//                                                         <div style={{ position: 'relative' }}>
//                                                             <UploadImage
//                                                                 name={`facilities[${index}].image1`}
//                                                                 formik={{ ...formikProps, values, setFieldValue }}
//                                                                 label="Image 1"
//                                                                 required={false}
//                                                             />

//                                                             <style>{`
//       .grid > div:not(:first-child) .form-text { display: none !important; }
//     `}</style>
//                                                         </div>
//                                                         <UploadImage
//                                                             name={`facilities[${index}].image2`}
//                                                             formik={{ ...formikProps, values, setFieldValue }}
//                                                             label="Image 2"
//                                                             required={false}
//                                                         />
//                                                         <UploadImage
//                                                             name={`facilities[${index}].image3`}
//                                                             formik={{ ...formikProps, values, setFieldValue }}
//                                                             label="Image 3"
//                                                             required={false}
//                                                         />
//                                                     </div>
//                                                 </div>


//                                                 <div className="flex gap-2">
//                                                     <button
//                                                         type="button"
//                                                         onClick={() => push({ facility: '', description: '', image1: '', image2: '', image3: '' })}
//                                                         className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm"
//                                                     >
//                                                         Add more
//                                                     </button>
//                                                     {index > 0 && (
//                                                         <button
//                                                             type="button"
//                                                             onClick={() => remove(index)}
//                                                             className="px-4 py-2 text-red-500 rounded-md hover:bg-red-50 text-sm flex items-center justify-center"
//                                                         >
//                                                             <KTIcon iconName='trash' className='fs-3' />
//                                                         </button>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 )}
//                             </FieldArray>
//                         </div> */}



//                         <div>
//                             <h2 className="text-xl font-semibold mb-4">Showcase your facility</h2>
//                             <FieldArray name="facilities">
//                                 {({ push, remove }) => (
//                                     <div className="space-y-3">
//                                         {values.facilities.map((_, index) => (
//                                             <div key={index} className="space-y-3">
//                                                 {/* Top row: Dropdown */}
//                                                 <div>
//                                                     <label className='required fw-bold fs-6 mb-2'>Select facility</label>
//                                                     <Field
//                                                         name={`facilities[${index}].facility`}
//                                                         as="select"
//                                                         style={{
//                                                             backgroundColor: '#ffffff',
//                                                             border: '1px solid #dddddd',
//                                                             color: '#000000',
//                                                         }}
//                                                         className="form-control form-control-solid mb-3 mb-lg-0"
//                                                         autoComplete='off'
//                                                     >
//                                                         <option value="">
//                                                             {facilitiesLoading ? 'Loading facilities...' : 'Choose a facility'}
//                                                         </option>
//                                                         {facilities.map((facility) => (
//                                                             <option key={facility.id} value={facility.id}>
//                                                                 {facility.personalDetails?.name || 'Unnamed Facility'}
//                                                             </option>
//                                                         ))}
//                                                     </Field>
//                                                     <ErrorMessage name={`facilities[${index}].facility`} component="div" className="text-red-500 text-sm mt-1" />
//                                                 </div>

//                                                 {/* Description row */}
//                                                 <div className="relative">
//                                                     <label className='required fw-bold fs-6 mb-2'>Add Description</label>
//                                                     <Field name={`facilities[${index}].description`}>
//                                                         {({ field, form }) => {
//                                                             const wordCount = field.value ? field.value.trim().split(/\s+/).filter(word => word.length > 0).length : 0;

//                                                             return (
//                                                                 <div>
//                                                                     <textarea
//                                                                         {...field}
//                                                                         rows={4}
//                                                                         className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                                         style={{ resize: 'none' }}
//                                                                         placeholder="Max 50 words"
//                                                                         onChange={(e) => {
//                                                                             const words = e.target.value.trim().split(/\s+/).filter(word => word.length > 0);
//                                                                             if (words.length <= 50 || e.target.value === '') {
//                                                                                 form.setFieldValue(field.name, e.target.value);
//                                                                             }
//                                                                         }}
//                                                                     />
//                                                                     <div className={`text-sm mt-1 ${wordCount > 50 ? 'text-red-500' : 'text-gray-500'}`}>
//                                                                         {wordCount}/50 words
//                                                                     </div>
//                                                                 </div>
//                                                             );
//                                                         }}
//                                                     </Field>
//                                                     <ErrorMessage name={`facilities[${index}].description`} component="div" className="text-red-500 text-sm mt-1" />
//                                                     <button
//                                                         type="button"
//                                                         onClick={() => push({ facility: '', description: '', image1: '', image2: '', image3: '' })}
//                                                         className="absolute -right-12 top-8 flex items-center justify-center w-10 h-10 text-white rounded-full hover:opacity-80"
//                                                         style={{ backgroundColor: '#0095e8' }}
//                                                     >
//                                                         <span className="text-xl font-bold">+</span>
//                                                     </button>
//                                                     {index > 0 && (
//                                                         <button
//                                                             type="button"
//                                                             onClick={() => remove(index)}
//                                                             className="absolute -right-12 top-16 p-2 text-red-500 rounded-md hover:bg-red-50 flex items-center justify-center mt-5"
//                                                         >
//                                                             <KTIcon iconName='trash' className='fs-3' />
//                                                         </button>
//                                                     )}
//                                                 </div>

//                                                 {/* Images row */}
//                                                 <div>
//                                                     <label className='required fw-bold fs-6 mb-2'>Facility Images</label>
//                                                     <div className="grid grid-cols-3 gap-4">
//                                                         <div style={{ position: 'relative' }}>
//                                                             <UploadImage
//                                                                 name={`facilities[${index}].image1`}
//                                                                 formik={{ ...formikProps, values, setFieldValue }}
//                                                                 label="Image 1"
//                                                                 required={false}
//                                                             />
//                                                             <style>{`
//                                        .grid > div:not(:first-child) .form-text { display: none !important; }
//                                    `}</style>
//                                                         </div>
//                                                         <UploadImage
//                                                             name={`facilities[${index}].image2`}
//                                                             formik={{ ...formikProps, values, setFieldValue }}
//                                                             label="Image 2"
//                                                             required={false}
//                                                         />
//                                                         <UploadImage
//                                                             name={`facilities[${index}].image3`}
//                                                             formik={{ ...formikProps, values, setFieldValue }}
//                                                             label="Image 3"
//                                                             required={false}
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 )}
//                             </FieldArray>
//                         </div>



//                         {/* Submit Button */}
//                         {/* <div className="flex justify-center">
//                             <button
//                                 type="submit"
//                                 className="px-8 py-3 bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
//                             >
//                                 SUBMIT
//                             </button>
//                         </div> */}



//                         {/* Submit Button */}
//                         <div className='text-center pt-15'>
//                             <button
//                                 type='reset'
//                                 onClick={() => cancel()}
//                                 className='btn btn-light me-3'
//                                 data-kt-users-modal-action='cancel'
//                                 disabled={loading || isUserLoading}
//                             >
//                                 Discard
//                             </button>
//                             <button
//                                 type='submit'
//                                 className='btn btn-primary'
//                                 data-kt-users-modal-action='submit'
//                                 disabled={isUserLoading || loading}
//                             >
//                                 <span className='indicator-label'>
//                                     {user && user.id ? 'Update' : 'Submit'}
//                                 </span>
//                                 {(loading || isUserLoading) && (
//                                     <span className='indicator-progress'>
//                                         Please wait...{' '}
//                                         <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
//                                     </span>
//                                 )}
//                             </button>
//                         </div>


//                     </Form>
//                 )}
//             </Formik>
//         </div>
//     );
// };

// export default ShowcaseForm;











import React, { useState, useEffect } from 'react';
import { Formik, Form, Field, FieldArray, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import UploadImage from '../../../../../../_metronic/helpers/components/ImageUpload';
import UploadVideo from '../../../../../../_metronic/helpers/components/ImageUpload/index2';
import { KTIcon } from '../../../../../../_metronic/helpers';
import { initialUser, User } from '../core/_models'
import { FC } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useListView } from '../core/ListViewProvider'
import { errorToast, successToast } from '../../../../../../_metronic/helpers/components/Toaster'


interface FacilityItem {
    facility: string;
    description: string;
    image1?: string;
    image2?: string;
    image3?: string;
}
// Types
interface SocialMediaLinks {
    website: string;
    linkedin: string;
    x: string;
    facebook: string;
    youtubeShowcase: string;
}

interface MediaItem {
    url: string;
    description: string;
    date: string;  // Add this
}

interface ShowcaseItem {
    customer: string;
    description: string;
}

interface FacilityItem {
    facility: string;
    description: string;
}

interface FormValues {
    socialMedia: SocialMediaLinks;
    images: MediaItem[];
    videos: MediaItem[];
    customers: ShowcaseItem[];
    facilities: FacilityItem[];
    sponsor: string;
}

interface Customer {
    id: string;
    personalDetails: {
        name: string;
    };
    companyDetails?: {  // Add this if it exists in your API
        name: string;
    };
    customerType?: string;
    totalDepositedQuantity?: number;
    createdAt?: number;
    address?: {
        street?: string;
        city?: string;
        state?: string;
        country?: string;
        zipCode?: string;  // Add this
        longitute?: number; // <- Add this
        latitute?: number;  // <- Add this
    };
    kycDocument?: Array<{
        docType: 'CLIENT_LOGO' | string;
        docUrl: string;
        docNumber: string;
    }>;
}

interface ApiResponse {
    data?: Customer[];
    totalElements?: number;
}


type Props = {
    isUserLoading?: boolean
    user?: User | any
    arrayDropdown?: any
}

// Validation Schema
const validationSchema = Yup.object({
    socialMedia: Yup.object({
        website: Yup.string().url('Invalid URL'),
        linkedin: Yup.string().url('Invalid URL'),
        x: Yup.string().url('Invalid URL'),
        facebook: Yup.string().url('Invalid URL'),
        youtubeShowcase: Yup.string().url('Invalid URL'),
    }),
    images: Yup.array().of(
        Yup.object({
            description: Yup.string()
                .test('word-count', 'Max 50 words', function (value) {
                    if (!value) return true;
                    const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
                    return wordCount <= 50;
                }),
        })
    ),
    videos: Yup.array().of(
        Yup.object({
            description: Yup.string()
                .test('word-count', 'Max 50 words', function (value) {
                    if (!value) return true;
                    const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
                    return wordCount <= 50;
                }),
        })
    ),
    customers: Yup.array().of(
        Yup.object({
            customer: Yup.string().required('Customer is required'),
            description: Yup.string()
                .test('word-count', 'Max 50 words', function (value) {
                    if (!value) return true;
                    const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
                    return wordCount <= 50;
                }),
        })
    ),
    facilities: Yup.array().of(
        Yup.object({
            facility: Yup.string().required('Facility is required'),
            description: Yup.string()
                .test('word-count', 'Max 50 words', function (value) {
                    if (!value) return true;
                    const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
                    return wordCount <= 50;
                }),
        })
    ),
    sponsor: Yup.string(),
});


const ShowcaseForm: FC<Props> = ({
    user = {},
    isUserLoading = false,
    arrayDropdown = [],
}) => {

    console.log("user is .....................", user)
    const { setItemIdForUpdate } = useListView()
    const { refetch } = useQueryResponse()
    const cancel = (withRefresh?: boolean) => {
        if (withRefresh) {
            refetch()
        }
        setItemIdForUpdate(undefined)
    }

    const [filePreviews, setFilePreviews] = useState<{ [key: string]: string }>({});
    const [customers, setCustomers] = useState<Customer[]>([]);
    const [loading, setLoading] = useState(false);

    // Add these new state variables for sponsor duplicate check
    const [existingEngagement, setExistingEngagement] = useState<any>(null);
    const [isCheckingExisting, setIsCheckingExisting] = useState(false);
    const [editingExistingId, setEditingExistingId] = useState<string | null>(null);

    const [facilities, setFacilities] = useState<Customer[]>([]);
    const [facilitiesLoading, setFacilitiesLoading] = useState(false);

    // Add this function to check for existing engagement
    const checkExistingEngagement = async (sponsorId: string, setFieldValue: any) => {
        if (!sponsorId) {
            // Reset form when no sponsor is selected
            resetFormToDefault(setFieldValue);
            return;
        }

        try {
            setIsCheckingExisting(true);

            const authData = localStorage.getItem('kt-auth-react-v');
            if (!authData) {
                console.error('No authentication token found');
                return;
            }

            const parsedAuth = JSON.parse(authData);
            const token = parsedAuth.data?.token;

            if (!token) {
                console.error('Token not found in authentication data');
                return;
            }

            // Get all engagements and check for existing sponsor
            const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}engagement`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': token,
                }
            });

            if (response.ok) {
                const result = await response.json();
                const engagements = result.data || result;

                // Find existing engagement with the same sponsorId
                const existingData = engagements.find((engagement: any) => engagement.sponsorId === sponsorId);

                if (existingData) {
                    // Automatically load existing engagement data
                    setExistingEngagement(existingData);
                    setEditingExistingId(existingData.id);
                    loadExistingEngagementData(existingData, setFieldValue);
                } else {
                    // Reset form for new engagement
                    setExistingEngagement(null);
                    setEditingExistingId(null);
                    resetFormToDefault(setFieldValue);
                }
            } else {
                // Reset form if API call fails
                resetFormToDefault(setFieldValue);
                throw new Error(`HTTP error! status: ${response.status}`);
            }
        } catch (error) {
            console.error('Error checking existing engagement:', error);
            resetFormToDefault(setFieldValue);
        } finally {
            setIsCheckingExisting(false);
        }

        return null;
    };

    // Add function to reset form to default values
    const resetFormToDefault = (setFieldValue: any) => {
        console.log('Resetting form to default values');

        // Reset all form fields to default values
        setFieldValue('socialMedia.website', '');
        setFieldValue('socialMedia.linkedin', '');
        setFieldValue('socialMedia.x', '');
        setFieldValue('socialMedia.facebook', '');
        setFieldValue('socialMedia.youtubeShowcase', '');

        // Reset arrays to single empty item
        setFieldValue('images', [{ url: '', description: '' }]);
        setFieldValue('videos', [{ url: '', description: '' }]);
        setFieldValue('customers', [{ customer: '', description: '' }]);
        setFieldValue('facilities', [{ facility: '', description: '', image1: '', image2: '', image3: '' }]);

        console.log('Form reset complete');
    };

    // Add function to load existing engagement data
    const loadExistingEngagementData = (engagementData: any, setFieldValue: any) => {
        console.log('Loading existing engagement data:', engagementData);

        const socialMedia = engagementData.social?.[0] || {};

        // Load social media data
        setFieldValue('socialMedia.website', socialMedia.website || '');
        setFieldValue('socialMedia.linkedin', socialMedia.linkedIn || '');
        setFieldValue('socialMedia.x', socialMedia.twitter || '');
        setFieldValue('socialMedia.facebook', socialMedia.facebook || '');
        setFieldValue('socialMedia.youtubeShowcase', socialMedia.ytVideo || '');

        // Load images data
        const imagesData = engagementData.images?.length > 0
            ? engagementData.images.map((img: any) => ({
                url: img.url || '',
                description: img.description || ''
            }))
            : [{ url: '', description: '' }];
        setFieldValue('images', imagesData);

        // Load videos data
        const videosData = engagementData.videos?.length > 0
            ? engagementData.videos.map((vid: any) => ({
                url: vid.url || '',
                description: vid.description || ''
            }))
            : [{ url: '', description: '' }];
        setFieldValue('videos', videosData);

        // Load customers data
        const customersData = engagementData.team?.length > 0
            ? engagementData.team.map((member: any) => {
                const customer = customers.find(c => c.personalDetails?.name === member.customerName);
                return {
                    customer: customer?.id || '',
                    description: member.description || ''
                };
            })
            : [{ customer: '', description: '' }];
        setFieldValue('customers', customersData);

        // Load facilities data
        const facilitiesData = engagementData.facilityList?.length > 0
            ? engagementData.facilityList.map((facility: any) => {
                const facilityMatch = facilities.find(f => f.personalDetails?.name === facility.pickupPointName);
                return {
                    facility: facilityMatch?.id || '',
                    description: facility.description || '',
                    image1: facility.images?.[0] || '',
                    image2: facility.images?.[1] || '',
                    image3: facility.images?.[2] || ''
                };
            })
            : [{ facility: '', description: '', image1: '', image2: '', image3: '' }];
        setFieldValue('facilities', facilitiesData);

        console.log('Data loading complete');
    };

    const fetchFacilities = async () => {
        try {
            setFacilitiesLoading(true);

            const authData = localStorage.getItem('kt-auth-react-v');
            if (!authData) {
                console.error('No authentication token found');
                return;
            }

            const parsedAuth = JSON.parse(authData);
            const token = parsedAuth.data?.token;

            if (!token) {
                console.error('Token not found in authentication data');
                return;
            }

            const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users?page=0&size=10&type=PICKUP_POINT`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Accept-Language': 'en-US,en;q=0.9',
                    'Authorization': token,
                    'Connection': 'keep-alive',
                    'Sec-Fetch-Dest': 'empty',
                    'Sec-Fetch-Mode': 'cors',
                    'Sec-Fetch-Site': 'cross-site',
                    'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/128.0.0.0 Safari/537.36',
                    'sec-ch-ua': '"Chromium";v="128", "Not;A=Brand";v="24", "Google Chrome";v="128"',
                    'sec-ch-ua-mobile': '?0',
                    'sec-ch-ua-platform': '"Windows"'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            setFacilities(result || []);
        } catch (error) {
            console.error('Error fetching facilities:', error);
        } finally {
            setFacilitiesLoading(false);
        }
    };

    const fetchCustomers = async () => {
        try {
            setLoading(true);

            // Get token from localStorage
            const authData = localStorage.getItem('kt-auth-react-v');
            if (!authData) {
                console.error('No authentication token found');
                return;
            }

            const parsedAuth = JSON.parse(authData);
            const token = parsedAuth.data?.token;

            if (!token) {
                console.error('Token not found in authentication data');
                return;
            }

            const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users?page=1&size=10&type=CUSTOMER`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Accept-Language': 'en-US,en;q=0.9',
                    'Authorization': token,
                    'Connection': 'keep-alive',
                    'Sec-Fetch-Dest': 'empty',
                    'Sec-Fetch-Mode': 'cors',
                    'Sec-Fetch-Site': 'cross-site',
                    'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/128.0.0.0 Safari/537.36',
                    'sec-ch-ua': '"Chromium";v="128", "Not;A=Brand";v="24", "Google Chrome";v="128"',
                    'sec-ch-ua-mobile': '?0',
                    'sec-ch-ua-platform': '"Windows"'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json(); // This is directly an array, not wrapped in data
            console.log('API Response:', result); // Add this for debugging
            setCustomers(result || []); // Use result directly, not result.data
        } catch (error) {
            console.error('Error fetching customers:', error);
        } finally {
            setLoading(false);
        }
    };

    const [sponsors, setSponsors] = useState<Customer[]>([]);
    const [sponsorsLoading, setSponsorsLoading] = useState(false);

    const fetchSponsors = async () => {
        try {
            setSponsorsLoading(true);

            const authData = localStorage.getItem('kt-auth-react-v');
            if (!authData) {
                console.error('No authentication token found');
                return;
            }

            const parsedAuth = JSON.parse(authData);
            const token = parsedAuth.data?.token;

            if (!token) {
                console.error('Token not found in authentication data');
                return;
            }

            const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users?page=1&size=10&type=SPONSOR`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Accept-Language': 'en-US,en;q=0.9',
                    'Authorization': token,
                    'Connection': 'keep-alive',
                    'Sec-Fetch-Dest': 'empty',
                    'Sec-Fetch-Mode': 'cors',
                    'Sec-Fetch-Site': 'cross-site',
                    'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/128.0.0.0 Safari/537.36',
                    'sec-ch-ua': '"Chromium";v="128", "Not;A=Brand";v="24", "Google Chrome";v="128"',
                    'sec-ch-ua-mobile': '?0',
                    'sec-ch-ua-platform': '"Windows"'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            setSponsors(result || []);
        } catch (error) {
            console.error('Error fetching sponsors:', error);
        } finally {
            setSponsorsLoading(false);
        }
    };

    // Add this to useEffect
    useEffect(() => {
        fetchCustomers();
        fetchFacilities();
        fetchSponsors(); // Add this line
    }, []);

    const handleFileChange = (
        event: React.ChangeEvent<HTMLInputElement>,
        setFieldValue: any,
        fieldName: string,
        index: number
    ) => {
        const file = event.target.files?.[0] || null;
        setFieldValue(`${fieldName}[${index}].file`, file);

        // Create preview URL
        if (file) {
            const previewUrl = URL.createObjectURL(file);
            setFilePreviews(prev => ({
                ...prev,
                [`${fieldName}_${index}`]: previewUrl
            }));
        } else {
            setFilePreviews(prev => {
                const newPreviews = { ...prev };
                delete newPreviews[`${fieldName}_${index}`];
                return newPreviews;
            });
        }
    };

    // Cleanup function to revoke object URLs
    useEffect(() => {
        return () => {
            Object.values(filePreviews).forEach(url => {
                URL.revokeObjectURL(url);
            });
        };
    }, [filePreviews]);

    const handleSubmit = async (values: FormValues) => {
        try {
            setLoading(true);

            // Get token from localStorage
            const authData = localStorage.getItem('kt-auth-react-v');
            if (!authData) {
                console.error('No authentication token found');
                alert('Authentication token not found. Please login again.');
                return;
            }

            const parsedAuth = JSON.parse(authData);
            const token = parsedAuth.data?.token;

            if (!token) {
                console.error('Token not found in authentication data');
                alert('Invalid authentication data. Please login again.');
                return;
            }


            const formatDate = (dateString) => {
                if (!dateString) return "";
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            };

            const imageUrls = values.images.filter(img => img.url).map(img => ({
                url: img.url,
                description: img.description || "",
                date: formatDate(img.date)
            }));

            const videoUrls = values.videos.filter(vid => vid.url).map(vid => ({
                url: vid.url,
                description: vid.description || "",
                date: formatDate(vid.date)
            }));

            // Convert form data to API payload format
            const payload = {
                social: [{
                    linkedIn: values.socialMedia.linkedin || "",
                    twitter: values.socialMedia.x || "",
                    facebook: values.socialMedia.facebook || "",
                    website: values.socialMedia.website || "",
                    ytVideo: values.socialMedia.youtubeShowcase || ""
                }],

                team: values.customers.map(customer => {
                    const selectedCustomer = customers.find(c => c.id === customer.customer);
                    if (!selectedCustomer) {
                        return {
                            // customerId: selectedCustomer.id, // Add this line
                            customerName: "",
                            address: "",
                            profile: "",
                            quantity: 1.0,
                            joiningDate: new Date().toISOString(),
                            description: customer.description || ""
                        };
                    }

                    return {
                        customerId: selectedCustomer.id,
                        customerName: selectedCustomer.personalDetails?.name || "",
                        address: "",
                        profile: selectedCustomer.customerType || "",
                        quantity: selectedCustomer.totalDepositedQuantity || 1.0,
                        joiningDate: selectedCustomer.createdAt ? new Date(selectedCustomer.createdAt).toISOString() : new Date().toISOString(),
                        description: customer.description || ""
                    };
                }),

                facilityList: values.facilities.map(facility => {
                    const selectedFacility = facilities.find(f => f.id === facility.facility);
                    if (!selectedFacility) {
                        return {
                            pickupPointName: "",
                            address: "",
                            images: [],
                            description: facility.description || "",
                            longitute: 0,
                            latitute: 0
                        };
                    }

                    const addressParts: string[] = [];
                    if (selectedFacility.address?.street) addressParts.push(selectedFacility.address.street);
                    if (selectedFacility.address?.city) addressParts.push(selectedFacility.address.city);
                    if (selectedFacility.address?.state) addressParts.push(selectedFacility.address.state);
                    if (selectedFacility.address?.country) addressParts.push(selectedFacility.address.country);
                    if (selectedFacility.address?.zipCode) addressParts.push(selectedFacility.address.zipCode);

                    const facilityImages: string[] = [];
                    if (facility.image1) facilityImages.push(facility.image1);
                    if (facility.image2) facilityImages.push(facility.image2);
                    if (facility.image3) facilityImages.push(facility.image3);

                    return {
                        pickupPointId: selectedFacility.id,
                        pickupPointName: selectedFacility.personalDetails?.name || "",
                        address: addressParts.join(", "),
                        images: facilityImages,
                        description: facility.description || "",
                        longitute: selectedFacility.address?.longitute || 0,
                        latitute: selectedFacility.address?.latitute || 0,
                    };
                }),

                images: imageUrls.filter(img => img.url),
                videos: videoUrls.filter(vid => vid.url),
                sponsorId: values.sponsor
            };

            console.log('Payload being sent:', payload);

            // Determine if it's edit mode - check both user.id and editingExistingId
            const isEditMode = (user && user.id) || editingExistingId;
            const engagementId = editingExistingId || user?.id;

            const apiUrl = isEditMode
                ? `${process.env.REACT_APP_BASE_API_URL}engagement/${engagementId}/update`
                : `${process.env.REACT_APP_BASE_API_URL}engagement`;

            const method = isEditMode ? 'PUT' : 'POST';

            console.log(`Making ${method} request to:`, apiUrl);

            const response = await fetch(apiUrl, {
                method: method,
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const errorData = await response.text();
                throw new Error(`HTTP error! status: ${response.status}, message: ${errorData}`);
            }

            const result = await response.json();
            console.log(`Form ${isEditMode ? 'updated' : 'submitted'} successfully:`, result);

            // Success handling with toast
            successToast(`${isEditMode ? 'Updated' : 'Added'} successfully!`);
            window.location.reload();

        } catch (error) {
            console.error(`Error ${(user && user.id) || editingExistingId ? 'updating' : 'submitting'} form:`, error);
            // alert(`Error ${user && user.id ? 'updating' : 'submitting'} form: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    // Keep your default initialValues
    const initialValues: FormValues = {
        socialMedia: {
            website: '',
            linkedin: '',
            x: '',
            facebook: '',
            youtubeShowcase: '',
        },
        images: [{ url: '', description: '', date: '' }],
        videos: [{ url: '', description: '', date: '' }],
        customers: [{ customer: '', description: '' }],
        facilities: [{ facility: '', description: '', image1: '', image2: '', image3: '' }],
        sponsor: '',
    };

    // Add state for dynamic initial values
    const [dynamicInitialValues, setDynamicInitialValues] = useState<FormValues>(initialValues);

    // Add this useEffect to update initial values when data is loaded
    // Updated useEffect with better condition
    useEffect(() => {
        if (user && Object.keys(user).length > 0) {
            const socialMedia = user.social?.[0] || {};

            const transformedValues: FormValues = {
                socialMedia: {
                    website: socialMedia.website || '',
                    linkedin: socialMedia.linkedIn || '',
                    x: socialMedia.twitter || '',
                    facebook: socialMedia.facebook || '',
                    youtubeShowcase: socialMedia.ytVideo || '',
                },
                images: user.images?.length > 0 ? user.images.map(img => ({
                    url: img.url || '',
                    description: img.description || ''
                })) : [{ url: '', description: '' }],
                videos: user.videos?.length > 0 ? user.videos.map(vid => ({
                    url: vid.url || '',
                    description: vid.description || ''
                })) : [{ url: '', description: '' }],
                customers: user.team?.length > 0 ? user.team.map(member => {
                    const customer = customers.find(c => c.personalDetails?.name === member.customerName);
                    return {
                        customer: customer?.id || '',
                        description: member.description || ''
                    };
                }) : [{ customer: '', description: '' }],
                facilities: user.facilityList?.length > 0 ? user.facilityList.map(facility => {
                    const facilityMatch = facilities.find(f => f.personalDetails?.name === facility.pickupPointName);
                    return {
                        facility: facilityMatch?.id || '',
                        description: facility.description || '',
                        image1: facility.images?.[0] || '',
                        image2: facility.images?.[1] || '',
                        image3: facility.images?.[2] || ''
                    };
                }) : [{ facility: '', description: '', image1: '', image2: '', image3: '' }],
                sponsor: user.sponsorId || '',
            };

            setDynamicInitialValues(transformedValues);
        }
    }, [user, customers, facilities, sponsors]);

    return (
        <div className="mx-auto p-6 bg-white">
            <Formik
                initialValues={dynamicInitialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize={true}
            >
                {({ values, setFieldValue, ...formikProps }) => (
                    <Form className="space-y-8">
                        {/* Select Sponsor - Modified */}
                        <div>
                            <label className='required fw-bold fs-6 mb-2'>Select Sponsor</label>
                            <div className="relative">
                                <Field name="sponsor">
                                    {({ field, form }) => (
                                        <select
                                            {...field}
                                            style={{
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #dddddd',
                                                color: '#000000',
                                                paddingLeft: '40px',
                                            }}
                                            className="form-control form-control-solid mb-3 mb-lg-0"
                                            onChange={async (e) => {
                                                const sponsorId = e.target.value;
                                                form.setFieldValue('sponsor', sponsorId);

                                                console.log('Sponsor changed to:', sponsorId);
                                                console.log('User:', user);
                                                console.log('EditingExistingId:', editingExistingId);

                                                // Always check for existing engagement and reset/load data accordingly
                                                await checkExistingEngagement(sponsorId, form.setFieldValue);
                                            }}
                                            disabled={isCheckingExisting}
                                        >
                                            <option value="">
                                                {isCheckingExisting
                                                    ? 'Checking existing engagement...'
                                                    : sponsorsLoading
                                                        ? 'Loading sponsors...'
                                                        : 'Choose a sponsor'
                                                }
                                            </option>
                                            {sponsors.map((sponsor) => {
                                                const logoUrl = sponsor.kycDocument?.find(doc => doc.docType === 'CLIENT_LOGO')?.docUrl;
                                                return (
                                                    <option key={sponsor.id} value={sponsor.id}>
                                                        {sponsor.companyDetails?.name || 'Unnamed Sponsor'}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    )}
                                </Field>

                                {/* Show image for selected sponsor */}
                                <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                                    {(() => {
                                        const selectedSponsor = sponsors.find(s => s.id === values.sponsor);
                                        const logoUrl = selectedSponsor?.kycDocument?.find(doc => doc.docType === 'CLIENT_LOGO')?.docUrl;

                                        return logoUrl ? (
                                            <img
                                                src={logoUrl}
                                                alt="Sponsor Logo"
                                                className="w-6 h-6 rounded-full object-cover"
                                            />
                                        ) : (
                                            <div className="w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center">
                                                <span className="text-xs text-gray-500">?</span>
                                            </div>
                                        );
                                    })()}
                                </div>
                            </div>
                            <ErrorMessage name="sponsor" component="div" className="text-red-500 text-sm mt-1" />
                        </div>

                        {/* Social Media Links */}
                        {/* <div>
                            <h2 className="text-xl font-semibold mb-4">Social Media Links</h2>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <div>
                                    <label className='required fw-bold fs-6 mb-2'>Website</label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                                            <img
                                                src="/website.jpg"
                                                alt="Website"
                                                className="w-5 h-5"
                                            />
                                        </div>
                                        <Field
                                            name="socialMedia.website"
                                            type="url"
                                            style={{
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #dddddd',
                                                color: '#000000',
                                                paddingLeft: '40px',
                                            }}
                                            className="form-control form-control-solid mb-3 mb-lg-0"
                                            placeholder="https://example.com"
                                            autoComplete='off'
                                        />
                                    </div>
                                    <ErrorMessage name="socialMedia.website" component="div" className="text-red-500 text-sm mt-1" />
                                </div>

                                <div>
                                    <label className='required fw-bold fs-6 mb-2'>LinkedIn</label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                                            <img
                                                src="/linkedin.png"
                                                alt="LinkedIn"
                                                className="w-5 h-5"
                                            />
                                        </div>
                                        <Field
                                            name="socialMedia.linkedin"
                                            type="url"
                                            style={{
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #dddddd',
                                                color: '#000000',
                                                paddingLeft: '40px',
                                            }}
                                            className="form-control form-control-solid mb-3 mb-lg-0"
                                            placeholder="https://linkedin.com/in/username"
                                            autoComplete='off'
                                        />
                                    </div>
                                    <ErrorMessage name="socialMedia.linkedin" component="div" className="text-red-500 text-sm mt-1" />
                                </div>

                                <div>
                                    <label className='required fw-bold fs-6 mb-2'>X</label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                                            <img
                                                src="/twitter.png"
                                                alt="X"
                                                className="w-5 h-5"
                                            />
                                        </div>
                                        <Field
                                            name="socialMedia.x"
                                            type="url"
                                            style={{
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #dddddd',
                                                color: '#000000',
                                                paddingLeft: '40px',
                                            }}
                                            className="form-control form-control-solid mb-3 mb-lg-0"
                                            placeholder="https://x.com/username"
                                            autoComplete='off'
                                        />
                                    </div>
                                    <ErrorMessage name="socialMedia.x" component="div" className="text-red-500 text-sm mt-1" />
                                </div>

                                <div>
                                    <label className='required fw-bold fs-6 mb-2'>Facebook</label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                                            <img
                                                src="/facebook.png"
                                                alt="Facebook"
                                                className="w-5 h-5"
                                            />
                                        </div>
                                        <Field
                                            name="socialMedia.facebook"
                                            type="url"
                                            style={{
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #dddddd',
                                                color: '#000000',
                                                paddingLeft: '40px',
                                            }}
                                            className="form-control form-control-solid mb-3 mb-lg-0"
                                            placeholder="https://facebook.com/username"
                                            autoComplete='off'
                                        />
                                    </div>
                                    <ErrorMessage name="socialMedia.facebook" component="div" className="text-red-500 text-sm mt-1" />
                                </div>

                                <div>
                                    <label className='required fw-bold fs-6 mb-2'>YouTube Showcase</label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                                            <img
                                                src="/youtube.png"
                                                alt="YouTube"
                                                className="w-5 h-5"
                                            />
                                        </div>
                                        <Field
                                            name="socialMedia.youtubeShowcase"
                                            type="url"
                                            style={{
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #dddddd',
                                                color: '#000000',
                                                paddingLeft: '40px',
                                            }}
                                            className="form-control form-control-solid mb-3 mb-lg-0"
                                            placeholder="https://youtube.com/watch?v=..."
                                            autoComplete='off'
                                        />
                                    </div>
                                    <ErrorMessage name="socialMedia.youtubeShowcase" component="div" className="text-red-500 text-sm mt-1" />
                                </div>
                            </div>
                        </div> */}

                        <div>
                            <h2 className="text-xl font-semibold mb-4">Social Media Links</h2>
                            <div className={`grid ${window.location.pathname === '/apps/makting/engagement/add-engagement' ? 'grid-cols-5' : 'grid-cols-1 md:grid-cols-3'} gap-4`}>
                                <div>
                                    <label className='required fw-bold fs-6 mb-2'>Website</label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                                            <img
                                                src="/website.jpg"
                                                alt="Website"
                                                className="w-5 h-5"
                                            />
                                        </div>
                                        <Field
                                            name="socialMedia.website"
                                            type="url"
                                            style={{
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #dddddd',
                                                color: '#000000',
                                                paddingLeft: '40px',
                                            }}
                                            className="form-control form-control-solid mb-3 mb-lg-0"
                                            placeholder="https://example.com"
                                            autoComplete='off'
                                        />
                                    </div>
                                    <ErrorMessage name="socialMedia.website" component="div" className="text-red-500 text-sm mt-1" />
                                </div>

                                <div>
                                    <label className='required fw-bold fs-6 mb-2'>LinkedIn</label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                                            <img
                                                src="/linkedin.png"
                                                alt="LinkedIn"
                                                className="w-5 h-5"
                                            />
                                        </div>
                                        <Field
                                            name="socialMedia.linkedin"
                                            type="url"
                                            style={{
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #dddddd',
                                                color: '#000000',
                                                paddingLeft: '40px',
                                            }}
                                            className="form-control form-control-solid mb-3 mb-lg-0"
                                            placeholder="https://linkedin.com/in/username"
                                            autoComplete='off'
                                        />
                                    </div>
                                    <ErrorMessage name="socialMedia.linkedin" component="div" className="text-red-500 text-sm mt-1" />
                                </div>

                                <div>
                                    <label className='required fw-bold fs-6 mb-2'>X</label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                                            <img
                                                src="/twitter.png"
                                                alt="X"
                                                className="w-5 h-5"
                                            />
                                        </div>
                                        <Field
                                            name="socialMedia.x"
                                            type="url"
                                            style={{
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #dddddd',
                                                color: '#000000',
                                                paddingLeft: '40px',
                                            }}
                                            className="form-control form-control-solid mb-3 mb-lg-0"
                                            placeholder="https://x.com/username"
                                            autoComplete='off'
                                        />
                                    </div>
                                    <ErrorMessage name="socialMedia.x" component="div" className="text-red-500 text-sm mt-1" />
                                </div>

                                <div>
                                    <label className='required fw-bold fs-6 mb-2'>Facebook</label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                                            <img
                                                src="/facebook.png"
                                                alt="Facebook"
                                                className="w-5 h-5"
                                            />
                                        </div>
                                        <Field
                                            name="socialMedia.facebook"
                                            type="url"
                                            style={{
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #dddddd',
                                                color: '#000000',
                                                paddingLeft: '40px',
                                            }}
                                            className="form-control form-control-solid mb-3 mb-lg-0"
                                            placeholder="https://facebook.com/username"
                                            autoComplete='off'
                                        />
                                    </div>
                                    <ErrorMessage name="socialMedia.facebook" component="div" className="text-red-500 text-sm mt-1" />
                                </div>

                                <div>
                                    <label className='required fw-bold fs-6 mb-2'>YouTube Showcase</label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                                            <img
                                                src="/youtube.png"
                                                alt="YouTube"
                                                className="w-5 h-5"
                                            />
                                        </div>
                                        <Field
                                            name="socialMedia.youtubeShowcase"
                                            type="url"
                                            style={{
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #dddddd',
                                                color: '#000000',
                                                paddingLeft: '40px',
                                            }}
                                            className="form-control form-control-solid mb-3 mb-lg-0"
                                            placeholder="https://youtube.com/watch?v=..."
                                            autoComplete='off'
                                        />
                                    </div>
                                    <ErrorMessage name="socialMedia.youtubeShowcase" component="div" className="text-red-500 text-sm mt-1" />
                                </div>
                            </div>
                        </div>

                        {/* Images Section */}
                        <div>
                            <h2 className="text-xl font-semibold mb-4">
                                Showcase any special event/initiative
                            </h2>
                            <FieldArray name="images">
                                {({ push, remove }) => (
                                    <div className="">
                                        {values.images.map((_, index) => (
                                            <div key={index}>
                                                <div className="flex items-start gap-3">
                                                    <div className="flex-shrink-0">
                                                        <UploadImage
                                                            name={`images[${index}].url`}
                                                            formik={{ ...formikProps, values, setFieldValue }}
                                                            label="Upload image"
                                                            required={false}
                                                        />
                                                    </div>
                                                    <div className="flex-1 relative">
                                                        <label className='required fw-bold fs-6 mb-2'>Description</label>
                                                        <Field name={`images[${index}].description`}>
                                                            {({ field, form }) => {
                                                                const wordCount = field.value ? field.value.trim().split(/\s+/).filter(word => word.length > 0).length : 0;

                                                                return (
                                                                    <div>
                                                                        <textarea
                                                                            {...field}
                                                                            rows={4}
                                                                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                            style={{ resize: 'none' }}
                                                                            placeholder="Max 50 words"
                                                                            onChange={(e) => {
                                                                                const words = e.target.value.trim().split(/\s+/).filter(word => word.length > 0);
                                                                                if (words.length <= 50 || e.target.value === '') {
                                                                                    form.setFieldValue(field.name, e.target.value);
                                                                                }
                                                                            }}
                                                                        />
                                                                        <div className={`text-sm mt-1 ${wordCount > 50 ? 'text-red-500' : 'text-gray-500'}`}>
                                                                            {wordCount}/50 words
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }}
                                                        </Field>
                                                        <ErrorMessage name={`images[${index}].description`} component="div" className="text-red-500 text-sm mt-1" />

                                                        <div className="mt-3" style={{ marginBottom: '60px' }}>
                                                            <label className='fw-bold fs-6 mb-2'>Event Date</label>
                                                            <Field
                                                                name={`images[${index}].date`}
                                                                type="date"
                                                                style={{
                                                                    backgroundColor: '#ffffff',
                                                                    border: '1px solid #dddddd',
                                                                    color: '#000000',
                                                                }}
                                                                className="form-control form-control-solid"
                                                            />
                                                        </div>
                                                        <button
                                                            type="button"
                                                            onClick={() => push({ file: null, description: '', date: '' })}
                                                            className="absolute -right-12 flex items-center justify-center w-10 h-10 text-white rounded-full hover:opacity-80"
                                                            style={{ backgroundColor: '#0095e8', top: '8px' }}
                                                        >
                                                            <span className="text-xl font-bold">+</span>
                                                        </button>
                                                        {index > 0 && (
                                                            <button
                                                                type="button"
                                                                onClick={() => remove(index)}
                                                                className="absolute -right-12 p-2 text-red-500 rounded-md hover:bg-red-50 flex items-center justify-center"
                                                                style={{ top: '56px' }}
                                                            >
                                                                <KTIcon iconName='trash' className='fs-3' />
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </FieldArray>
                        </div>

                        {/* Videos Section */}
                        <div style={{ marginTop: "-20px" }}>
                            <h2 className="text-xl font-semibold mb-4">Showcase any special event/initiative</h2>
                            <FieldArray name="videos">
                                {({ push, remove }) => (
                                    <div className="" >
                                        {values.videos.map((_, index) => (
                                            <div key={index}>
                                                <div className="flex items-start gap-3">
                                                    <div className="flex-shrink-0">
                                                        <UploadVideo
                                                            name={`videos[${index}].url`}
                                                            formik={{ ...formikProps, values, setFieldValue }}
                                                            label="Upload Video"
                                                            required={false}
                                                        />
                                                    </div>
                                                    <div className="flex-1 relative">
                                                        <label className='required fw-bold fs-6 mb-2'>Description</label>
                                                        <Field name={`videos[${index}].description`}>
                                                            {({ field, form }) => {
                                                                const wordCount = field.value ? field.value.trim().split(/\s+/).filter(word => word.length > 0).length : 0;

                                                                return (
                                                                    <div>
                                                                        <textarea
                                                                            {...field}
                                                                            rows={4}
                                                                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                            style={{ resize: 'none' }}
                                                                            placeholder="Max 50 words"
                                                                            onChange={(e) => {
                                                                                const words = e.target.value.trim().split(/\s+/).filter(word => word.length > 0);
                                                                                if (words.length <= 50 || e.target.value === '') {
                                                                                    form.setFieldValue(field.name, e.target.value);
                                                                                }
                                                                            }}
                                                                        />
                                                                        <div className={`text-sm mt-1 ${wordCount > 50 ? 'text-red-500' : 'text-gray-500'}`}>
                                                                            {wordCount}/50 words
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }}
                                                        </Field>
                                                        <ErrorMessage name={`videos[${index}].description`} component="div" className="text-red-500 text-sm mt-1" />

                                                        <div className="mt-3" style={{ marginBottom: '60px' }}>
                                                            <label className='fw-bold fs-6 mb-2'>Event Date</label>
                                                            <Field
                                                                name={`videos[${index}].date`}
                                                                type="date"
                                                                style={{
                                                                    backgroundColor: '#ffffff',
                                                                    border: '1px solid #dddddd',
                                                                    color: '#000000',
                                                                }}
                                                                className="form-control form-control-solid"
                                                            />
                                                        </div>
                                                        <button
                                                            type="button"
                                                            onClick={() => push({ file: null, description: '', date: '' })}
                                                            className="absolute -right-12 flex items-center justify-center w-10 h-10 text-white rounded-full hover:opacity-80"
                                                            style={{ backgroundColor: '#0095e8', top: '8px' }}
                                                        >
                                                            <span className="text-xl font-bold">+</span>
                                                        </button>
                                                        {index > 0 && (
                                                            <button
                                                                type="button"
                                                                onClick={() => remove(index)}
                                                                className="absolute -right-12 p-2 text-red-500 rounded-md hover:bg-red-50 flex items-center justify-center"
                                                                style={{ top: '56px' }}
                                                            >
                                                                <KTIcon iconName='trash' className='fs-3' />
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </FieldArray>
                        </div>

                        {/* Showcase your customers */}
                        <div style={{ marginTop: "-20px" }}>
                            <h2 className="text-xl font-semibold mb-4">Showcase Plastic Keepers</h2>
                            <FieldArray name="customers">
                                {({ push, remove }) => (
                                    <div className="space-y-3">
                                        {values.customers.map((_, index) => (
                                            <div key={index}>
                                                <div className="space-y-3">
                                                    <div className="relative">
                                                        <label className='required fw-bold fs-6 mb-2'>Select Plastic Keepers</label>
                                                        <Field
                                                            name={`customers[${index}].customer`}
                                                            as="select"
                                                            style={{
                                                                backgroundColor: '#ffffff',
                                                                border: '1px solid #dddddd',
                                                                color: '#000000',
                                                            }}
                                                            className="form-control form-control-solid mb-3 mb-lg-0"
                                                            autoComplete='off'
                                                        >
                                                            <option value="">
                                                                {loading ? 'Loading customers...' : 'Choose a customer'}
                                                            </option>
                                                            {customers.map((customer) => (
                                                                <option key={customer.id} value={customer.id}>
                                                                    {customer.personalDetails?.name || 'Unnamed Customer'}
                                                                </option>
                                                            ))}
                                                        </Field>
                                                        <ErrorMessage name={`customers[${index}].customer`} component="div" className="text-red-500 text-sm mt-1" />
                                                    </div>
                                                    <div className="relative">
                                                        <label className='required fw-bold fs-6 mb-2'>Add Description</label>
                                                        <Field name={`customers[${index}].description`}>
                                                            {({ field, form }) => {
                                                                const wordCount = field.value ? field.value.trim().split(/\s+/).filter(word => word.length > 0).length : 0;

                                                                return (
                                                                    <div>
                                                                        <textarea
                                                                            {...field}
                                                                            rows={4}
                                                                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                            style={{ resize: 'none' }}
                                                                            placeholder="Max 50 words"
                                                                            onChange={(e) => {
                                                                                const words = e.target.value.trim().split(/\s+/).filter(word => word.length > 0);
                                                                                if (words.length <= 50 || e.target.value === '') {
                                                                                    form.setFieldValue(field.name, e.target.value);
                                                                                }
                                                                            }}
                                                                        />
                                                                        <div className={`text-sm mt-1 ${wordCount > 50 ? 'text-red-500' : 'text-gray-500'}`}>
                                                                            {wordCount}/50 words
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }}
                                                        </Field>
                                                        <ErrorMessage name={`customers[${index}].description`} component="div" className="text-red-500 text-sm mt-1" />
                                                        <button
                                                            type="button"
                                                            onClick={() => push({ customer: '', description: '' })}
                                                            className="absolute -right-12 top-8 flex items-center justify-center w-10 h-10 text-white rounded-full hover:opacity-80"
                                                            style={{ backgroundColor: '#0095e8' }}
                                                        >
                                                            <span className="text-xl font-bold">+</span>
                                                        </button>
                                                        {index > 0 && (
                                                            <button
                                                                type="button"
                                                                onClick={() => remove(index)}
                                                                className="absolute -right-12 top-16 p-2 text-red-500 rounded-md hover:bg-red-50 flex items-center justify-center mt-5"
                                                            >
                                                                <KTIcon iconName='trash' className='fs-3' />
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </FieldArray>
                        </div>

                        {/* Showcase your facility */}
                        <div>
                            <h2 className="text-xl font-semibold mb-4">Showcase Material Hub</h2>
                            <FieldArray name="facilities">
                                {({ push, remove }) => (
                                    <div className="space-y-3">
                                        {values.facilities.map((_, index) => (
                                            <div key={index} className="space-y-3">
                                                {/* Top row: Dropdown */}
                                                <div>
                                                    <label className='required fw-bold fs-6 mb-2'>Select Material Hub</label>
                                                    <Field
                                                        name={`facilities[${index}].facility`}
                                                        as="select"
                                                        style={{
                                                            backgroundColor: '#ffffff',
                                                            border: '1px solid #dddddd',
                                                            color: '#000000',
                                                        }}
                                                        className="form-control form-control-solid mb-3 mb-lg-0"
                                                        autoComplete='off'
                                                    >
                                                        <option value="">
                                                            {facilitiesLoading ? 'Loading facilities...' : 'Choose a facility'}
                                                        </option>
                                                        {facilities.map((facility) => (
                                                            <option key={facility.id} value={facility.id}>
                                                                {facility.personalDetails?.name || 'Unnamed Facility'}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                    <ErrorMessage name={`facilities[${index}].facility`} component="div" className="text-red-500 text-sm mt-1" />
                                                </div>

                                                {/* Description row */}
                                                <div className="relative">
                                                    <label className='required fw-bold fs-6 mb-2'>Add Description</label>
                                                    <Field name={`facilities[${index}].description`}>
                                                        {({ field, form }) => {
                                                            const wordCount = field.value ? field.value.trim().split(/\s+/).filter(word => word.length > 0).length : 0;

                                                            return (
                                                                <div>
                                                                    <textarea
                                                                        {...field}
                                                                        rows={4}
                                                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                        style={{ resize: 'none' }}
                                                                        placeholder="Max 50 words"
                                                                        onChange={(e) => {
                                                                            const words = e.target.value.trim().split(/\s+/).filter(word => word.length > 0);
                                                                            if (words.length <= 50 || e.target.value === '') {
                                                                                form.setFieldValue(field.name, e.target.value);
                                                                            }
                                                                        }}
                                                                    />
                                                                    <div className={`text-sm mt-1 ${wordCount > 50 ? 'text-red-500' : 'text-gray-500'}`}>
                                                                        {wordCount}/50 words
                                                                    </div>
                                                                </div>
                                                            );
                                                        }}
                                                    </Field>
                                                    <ErrorMessage name={`facilities[${index}].description`} component="div" className="text-red-500 text-sm mt-1" />
                                                    <button
                                                        type="button"
                                                        onClick={() => push({ facility: '', description: '', image1: '', image2: '', image3: '' })}
                                                        className="absolute -right-12 top-8 flex items-center justify-center w-10 h-10 text-white rounded-full hover:opacity-80"
                                                        style={{ backgroundColor: '#0095e8' }}
                                                    >
                                                        <span className="text-xl font-bold">+</span>
                                                    </button>
                                                    {index > 0 && (
                                                        <button
                                                            type="button"
                                                            onClick={() => remove(index)}
                                                            className="absolute -right-12 top-16 p-2 text-red-500 rounded-md hover:bg-red-50 flex items-center justify-center mt-5"
                                                        >
                                                            <KTIcon iconName='trash' className='fs-3' />
                                                        </button>
                                                    )}
                                                </div>

                                                {/* Images row */}
                                                <div>
                                                    <label className='required fw-bold fs-6 mb-2'>Facility Images</label>
                                                    <div className="grid grid-cols-3 gap-4">
                                                        <div style={{ position: 'relative' }}>
                                                            <UploadImage
                                                                name={`facilities[${index}].image1`}
                                                                formik={{ ...formikProps, values, setFieldValue }}
                                                                label="Image 1"
                                                                required={false}
                                                            />
                                                            <style>{`
                                       .grid > div:not(:first-child) .form-text { display: none !important; }
                                   `}</style>
                                                        </div>
                                                        <UploadImage
                                                            name={`facilities[${index}].image2`}
                                                            formik={{ ...formikProps, values, setFieldValue }}
                                                            label="Image 2"
                                                            required={false}
                                                        />
                                                        <UploadImage
                                                            name={`facilities[${index}].image3`}
                                                            formik={{ ...formikProps, values, setFieldValue }}
                                                            label="Image 3"
                                                            required={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </FieldArray>
                        </div>

                        {/* Submit Button */}
                        <div className='text-center pt-15'>
                            <button
                                type='reset'
                                onClick={() => cancel()}
                                className='btn btn-light me-3'
                                data-kt-users-modal-action='cancel'
                                disabled={loading || isUserLoading}
                            >
                                Discard
                            </button>
                            <button
                                type='submit'
                                style={{ background: "black", color: "white" }}
                                className='btn'
                                data-kt-users-modal-action='submit'
                                disabled={isUserLoading || loading}
                            >
                                <span className='indicator-label'>
                                    {(user && user.id) || editingExistingId ? 'Update' : 'Submit'}
                                </span>
                                {(loading || isUserLoading) && (
                                    <span className='indicator-progress'>
                                        Please wait...{' '}
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                    </span>
                                )}
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default ShowcaseForm;